import { ApolloClient } from "@apollo/client/core";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Time: any;
  Void: any;
};

export type Accordion = {
  __typename?: 'Accordion';
  body: Scalars['String'];
  isOpen: Scalars['Boolean'];
  title: Scalars['String'];
};

export type AddScheduleSlotError = {
  __typename?: 'AddScheduleSlotError';
  message: Scalars['String'];
};

export type AddScheduleSlotErrorDay = AddScheduleSlotError | Day;

export enum AgeGroup {
  Range_11_18 = 'range_11_18',
  Range_19_24 = 'range_19_24',
  Range_25_34 = 'range_25_34',
  Range_35_44 = 'range_35_44',
  Range_45_54 = 'range_45_54',
  Range_55_64 = 'range_55_64',
  RangeLessThan_10 = 'range_less_than_10',
  RangeMoreThan_65 = 'range_more_than_65'
}

export type AlreadySubscribed = {
  __typename?: 'AlreadySubscribed';
  message: Scalars['String'];
};

export type Answer = {
  __typename?: 'Answer';
  answer: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
};

export type AnswerInput = {
  answer: Scalars['String'];
  options?: InputMaybe<Array<Scalars['ID']>>;
  question: Scalars['ID'];
};

export type Attendee = {
  __typename?: 'Attendee';
  email: Scalars['String'];
  fullName: Scalars['String'];
};

export type AttendeeTicket = {
  __typename?: 'AttendeeTicket';
  email?: Maybe<Scalars['String']>;
  hashid: Scalars['ID'];
  id: Scalars['ID'];
  item: TicketItem;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<ConferenceRole>;
  secret: Scalars['String'];
  variation?: Maybe<Scalars['ID']>;
};

export type AudienceLevel = {
  __typename?: 'AudienceLevel';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AvailableCards = PriceCard | SimpleTextCard;

export type AvatarUploadUrl = {
  __typename?: 'AvatarUploadUrl';
  fileUrl: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type BadgeScan = {
  __typename?: 'BadgeScan';
  attendee: Attendee;
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  notes: Scalars['String'];
};

export type BadgeScanExport = {
  __typename?: 'BadgeScanExport';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type BadgeScanPaginated = {
  __typename?: 'BadgeScanPaginated';
  items: Array<BadgeScan>;
  pageInfo: PageInfo;
};

export type BadgeScanScanError = BadgeScan | ScanError;

export type BedLayout = {
  __typename?: 'BedLayout';
  id: Scalars['String'];
  name: Scalars['String'];
};


export type BedLayoutNameArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type Block = CmsMap | CheckoutSection | HomeIntroSection | InformationSection | KeynotersSection | LiveStreamingSection | NewsGridSection | SchedulePreviewSection | SliderCardsSection | SocialsSection | SpecialGuestSection | SponsorsSection | TextSection;

export type BlogPostAuthor = {
  __typename?: 'BlogPostAuthor';
  fullName: Scalars['String'];
  id: Scalars['ID'];
};

export enum BodyTextSize {
  Text_1 = 'TEXT_1',
  Text_2 = 'TEXT_2'
}

export type BookScheduleItemResult = ScheduleItem | ScheduleItemIsFull | ScheduleItemNotBookable | UserIsAlreadyBooked | UserNeedsConferenceTicket;

export type CmsMap = {
  __typename?: 'CMSMap';
  id: Scalars['ID'];
  image: Scalars['String'];
  latitude: Scalars['Decimal'];
  link: Scalars['String'];
  longitude: Scalars['Decimal'];
  zoom: Scalars['Int'];
};


export type CmsMapImageArgs = {
  height?: Scalars['Int'];
  width?: Scalars['Int'];
};

export type Cta = {
  __typename?: 'CTA';
  label: Scalars['String'];
  link: Scalars['String'];
};

export type CancelBookingScheduleItemResult = ScheduleItem | ScheduleItemNotBookable | UserIsNotBooked;

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export enum CheckoutCategory {
  Gadgets = 'GADGETS',
  Hotel = 'HOTEL',
  Membership = 'MEMBERSHIP',
  SocialEvents = 'SOCIAL_EVENTS',
  Tickets = 'TICKETS',
  Tours = 'TOURS'
}

export type CheckoutSection = {
  __typename?: 'CheckoutSection';
  id: Scalars['ID'];
  visibleCategories: Array<CheckoutCategory>;
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  stripeSessionId: Scalars['String'];
};

export type Conference = {
  __typename?: 'Conference';
  audienceLevels: Array<AudienceLevel>;
  code: Scalars['String'];
  copy?: Maybe<Scalars['String']>;
  currentDay?: Maybe<Day>;
  days: Array<Day>;
  deadline?: Maybe<Deadline>;
  deadlines: Array<Deadline>;
  durations: Array<Duration>;
  end: Scalars['DateTime'];
  events: Array<Event>;
  faqs: Array<Faq>;
  hotelRooms: Array<HotelRoom>;
  id: Scalars['ID'];
  introduction: Scalars['String'];
  isCFPOpen: Scalars['Boolean'];
  isRunning: Scalars['Boolean'];
  isVotingClosed: Scalars['Boolean'];
  isVotingOpen: Scalars['Boolean'];
  keynote?: Maybe<Keynote>;
  keynotes: Array<Keynote>;
  languages: Array<Language>;
  map?: Maybe<Map>;
  menu?: Maybe<Menu>;
  name: Scalars['String'];
  pretixEventUrl: Scalars['String'];
  ranking?: Maybe<RankRequest>;
  sponsorsByLevel: Array<SponsorsByLevel>;
  start: Scalars['DateTime'];
  submissionTypes: Array<SubmissionType>;
  submissions?: Maybe<Array<Submission>>;
  talk?: Maybe<ScheduleItem>;
  talks: Array<ScheduleItem>;
  tickets: Array<TicketItem>;
  timezone: Scalars['String'];
  topics: Array<Topic>;
  voucher?: Maybe<Voucher>;
};


export type ConferenceCopyArgs = {
  key: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
};


export type ConferenceDeadlineArgs = {
  type: Scalars['String'];
};


export type ConferenceIntroductionArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type ConferenceKeynoteArgs = {
  slug: Scalars['String'];
};


export type ConferenceMenuArgs = {
  identifier: Scalars['String'];
};


export type ConferenceNameArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type ConferenceRankingArgs = {
  topic: Scalars['ID'];
};


export type ConferenceTalkArgs = {
  slug: Scalars['String'];
};


export type ConferenceTicketsArgs = {
  language: Scalars['String'];
  showUnavailableTickets?: Scalars['Boolean'];
};


export type ConferenceVoucherArgs = {
  code: Scalars['String'];
};

export enum ConferenceRole {
  Attendee = 'ATTENDEE',
  DjangoGirls = 'DJANGO_GIRLS',
  Keynoter = 'KEYNOTER',
  Speaker = 'SPEAKER',
  Sponsor = 'SPONSOR',
  Staff = 'STAFF'
}

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CreateOrderHotelRoom = {
  bedLayoutId: Scalars['String'];
  checkin: Scalars['Date'];
  checkout: Scalars['Date'];
  roomId: Scalars['String'];
};

export type CreateOrderInput = {
  email: Scalars['String'];
  hotelRooms: Array<CreateOrderHotelRoom>;
  invoiceInformation: InvoiceInformation;
  locale: Scalars['String'];
  paymentProvider: Scalars['String'];
  tickets: Array<CreateOrderTicket>;
};

export type CreateOrderResult = {
  __typename?: 'CreateOrderResult';
  paymentUrl: Scalars['String'];
};

export type CreateOrderResultError = CreateOrderResult | Error;

export type CreateOrderTicket = {
  answers?: InputMaybe<Array<CreateOrderTicketAnswer>>;
  attendeeEmail: Scalars['String'];
  attendeeName: Scalars['String'];
  ticketId: Scalars['String'];
  variation?: InputMaybe<Scalars['String']>;
  voucher?: InputMaybe<Scalars['String']>;
};

export type CreateOrderTicketAnswer = {
  questionId: Scalars['String'];
  value: Scalars['String'];
};

export type CustomerPortalResponse = {
  __typename?: 'CustomerPortalResponse';
  billingPortalUrl: Scalars['String'];
};

export type CustomerPortalResult = CustomerPortalResponse | NoSubscription | NotSubscribedViaStripe;

export type Day = {
  __typename?: 'Day';
  day: Scalars['Date'];
  randomEvents: Array<ScheduleItem>;
  rooms: Array<DayRoom>;
  runningEvents: Array<ScheduleItem>;
  slots: Array<ScheduleSlot>;
};


export type DayRandomEventsArgs = {
  limit?: Scalars['Int'];
};


export type DaySlotsArgs = {
  room?: InputMaybe<Scalars['ID']>;
};

export type DayRoom = {
  __typename?: 'DayRoom';
  id: Scalars['ID'];
  name: Scalars['String'];
  slidoUrl: Scalars['String'];
  streamingUrl: Scalars['String'];
  type: Scalars['String'];
};

export type Deadline = {
  __typename?: 'Deadline';
  conference: Conference;
  description: Scalars['String'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  start: Scalars['DateTime'];
  status: DeadlineStatus;
  type: Scalars['String'];
};


export type DeadlineDescriptionArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type DeadlineNameArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export enum DeadlineStatus {
  HappeningNow = 'HAPPENING_NOW',
  InTheFuture = 'IN_THE_FUTURE',
  InThePast = 'IN_THE_PAST'
}

export type Duration = {
  __typename?: 'Duration';
  allowedSubmissionTypes: Array<SubmissionType>;
  conference: Conference;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
};

export type EmailAlreadyUsed = {
  __typename?: 'EmailAlreadyUsed';
  message: Scalars['String'];
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  conference: Conference;
  content: Scalars['String'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  map?: Maybe<Map>;
  slug: Scalars['String'];
  start: Scalars['DateTime'];
  title: Scalars['String'];
};


export type EventContentArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type EventSlugArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type EventTitleArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type Faq = {
  __typename?: 'FAQ';
  answer: Scalars['String'];
  id: Scalars['ID'];
  question: Scalars['String'];
};


export type FaqAnswerArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type FaqQuestionArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type FieldError = {
  __typename?: 'FieldError';
  message: Scalars['String'];
  type: Scalars['String'];
};

export type GenericPage = {
  __typename?: 'GenericPage';
  body: Array<Block>;
  id: Scalars['ID'];
  searchDescription: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type GenericPageSiteNotFoundError = GenericPage | SiteNotFoundError;

export type Grant = {
  __typename?: 'Grant';
  ageGroup?: Maybe<AgeGroup>;
  applicantMessage?: Maybe<Scalars['String']>;
  applicantReplyDeadline?: Maybe<Scalars['DateTime']>;
  beenToOtherEvents: Scalars['String'];
  fullName: Scalars['String'];
  gender: Scalars['String'];
  grantType: GrantType;
  id: Scalars['ID'];
  interestedInVolunteering: InterestedInVolunteering;
  name: Scalars['String'];
  needsFundsForTravel: Scalars['Boolean'];
  notes: Scalars['String'];
  occupation: Occupation;
  pythonUsage: Scalars['String'];
  status: Status;
  travellingFrom: Scalars['String'];
  why: Scalars['String'];
};

export type GrantErrors = {
  __typename?: 'GrantErrors';
  ageGroup: Array<Scalars['String']>;
  beenToOtherEvents: Array<Scalars['String']>;
  conference: Array<Scalars['String']>;
  fullName: Array<Scalars['String']>;
  gender: Array<Scalars['String']>;
  grantType: Array<Scalars['String']>;
  instance: Array<Scalars['String']>;
  interestedInVolunteering: Array<Scalars['String']>;
  name: Array<Scalars['String']>;
  needsFundsForTravel: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
  notes: Array<Scalars['String']>;
  occupation: Array<Scalars['String']>;
  pythonUsage: Array<Scalars['String']>;
  travellingFrom: Array<Scalars['String']>;
  why: Array<Scalars['String']>;
};

export enum GrantType {
  Diversity = 'diversity',
  Speaker = 'speaker',
  Unemployed = 'unemployed'
}

export type HomeIntroSection = {
  __typename?: 'HomeIntroSection';
  id: Scalars['ID'];
  pretitle: Scalars['String'];
  title: Scalars['String'];
};

export type HotelRoom = {
  __typename?: 'HotelRoom';
  availableBedLayouts: Array<BedLayout>;
  capacityLeft: Scalars['Int'];
  checkInDates: Array<Scalars['String']>;
  checkOutDates: Array<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  isSoldOut: Scalars['Boolean'];
  name: Scalars['String'];
  price: Scalars['String'];
};


export type HotelRoomDescriptionArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type HotelRoomNameArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type InformationSection = {
  __typename?: 'InformationSection';
  backgroundColor: Scalars['String'];
  body: Scalars['String'];
  countdownToDatetime?: Maybe<Scalars['DateTime']>;
  countdownToDeadline?: Maybe<Scalars['String']>;
  cta?: Maybe<Cta>;
  id: Scalars['ID'];
  illustration: Scalars['String'];
  title: Scalars['String'];
};

export enum InterestedInVolunteering {
  Absolutely = 'absolutely',
  No = 'no',
  Yes = 'yes'
}

export type InvoiceInformation = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  fiscalCode: Scalars['String'];
  isBusiness: Scalars['Boolean'];
  name: Scalars['String'];
  street: Scalars['String'];
  vatId: Scalars['String'];
  zipcode: Scalars['String'];
};

export type JobListing = {
  __typename?: 'JobListing';
  applyUrl: Scalars['String'];
  company: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type JobListingDescriptionArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type JobListingSlugArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type JobListingTitleArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type Keynote = {
  __typename?: 'Keynote';
  description: Scalars['String'];
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  rooms: Array<Room>;
  slug: Scalars['String'];
  speakers: Array<ScheduleItemUser>;
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  topic?: Maybe<Topic>;
  youtubeVideoId?: Maybe<Scalars['String']>;
};


export type KeynoteDescriptionArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type KeynoteSlugArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type KeynoteTitleArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type KeynotersSection = {
  __typename?: 'KeynotersSection';
  cta?: Maybe<Cta>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LiveStreamingSection = {
  __typename?: 'LiveStreamingSection';
  id: Scalars['ID'];
};

export type LoginErrors = {
  __typename?: 'LoginErrors';
  email?: Maybe<Array<FieldError>>;
  password?: Maybe<Array<FieldError>>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginResult = LoginSuccess | LoginValidationError | WrongEmailOrPassword;

export type LoginSuccess = {
  __typename?: 'LoginSuccess';
  user: User;
};

export type LoginValidationError = {
  __typename?: 'LoginValidationError';
  errors: LoginErrors;
};

export type Map = {
  __typename?: 'Map';
  id: Scalars['ID'];
  image: Scalars['String'];
  latitude: Scalars['Decimal'];
  link?: Maybe<Scalars['String']>;
  longitude: Scalars['Decimal'];
};


export type MapImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
  zoom?: InputMaybe<Scalars['Int']>;
};

export type Menu = {
  __typename?: 'Menu';
  links: Array<MenuLink>;
  title: Scalars['String'];
};


export type MenuTitleArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type MenuLink = {
  __typename?: 'MenuLink';
  href: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  page?: Maybe<Page>;
  title: Scalars['String'];
};


export type MenuLinkHrefArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type MenuLinkTitleArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type MultiLingualInput = {
  en?: Scalars['String'];
  it?: Scalars['String'];
};

export type MultiLingualString = {
  __typename?: 'MultiLingualString';
  en: Scalars['String'];
  it: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addScheduleSlot: AddScheduleSlotErrorDay;
  bookScheduleItem: BookScheduleItemResult;
  cancelBookingScheduleItem: CancelBookingScheduleItemResult;
  createOrder: CreateOrderResultError;
  exportBadgeScans: BadgeScanExport;
  generateParticipantAvatarUploadUrl: AvatarUploadUrl;
  login: LoginResult;
  logout: Scalars['String'];
  manageUserSubscription: CustomerPortalResult;
  register: RegisterResult;
  registerVolunteerDevice: Scalars['Boolean'];
  requestResetPassword: RequestResetPasswordResult;
  resetPassword: ResetPasswordResult;
  scanBadge: BadgeScanScanError;
  sendGrant: SendGrantResult;
  sendGrantReply: SendGrantReplyResult;
  sendSubmission: SendSubmissionOutput;
  sendVote: SendVoteOutput;
  starScheduleItem?: Maybe<Scalars['Void']>;
  subscribeToNewsletter: SubscribeToNewsletterOutput;
  subscribeUserToAssociation: SubscribeUserResult;
  unstarScheduleItem?: Maybe<Scalars['Void']>;
  unsubscribeToNewsletter: UnsubscribeToNewsletterOutput;
  updateAttendeeTicket: UpdateAttendeeTicketResult;
  updateBadgeScan: BadgeScanScanError;
  updateGrant: UpdateGrantResult;
  updateOrCreateSlotItem: UpdateOrCreateSlotItemErrorUpdateOrCreateSlotItemResult;
  updateParticipant: UpdateParticipantResult;
  updateProfile: UpdateProfileResult;
  updateScheduleInvitation: ScheduleInvitationNotFoundScheduleInvitation;
  updateSubmission: UpdateSubmissionOutput;
};


export type MutationAddScheduleSlotArgs = {
  conference: Scalars['ID'];
  day: Scalars['Date'];
  duration: Scalars['Int'];
};


export type MutationBookScheduleItemArgs = {
  id: Scalars['ID'];
};


export type MutationCancelBookingScheduleItemArgs = {
  id: Scalars['ID'];
};


export type MutationCreateOrderArgs = {
  conference: Scalars['String'];
  input: CreateOrderInput;
};


export type MutationExportBadgeScansArgs = {
  conferenceCode: Scalars['String'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRegisterVolunteerDeviceArgs = {
  deviceToken: Scalars['String'];
  platform: Platform;
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationScanBadgeArgs = {
  input: ScanBadgeInput;
};


export type MutationSendGrantArgs = {
  input: SendGrantInput;
};


export type MutationSendGrantReplyArgs = {
  input: SendGrantReplyInput;
};


export type MutationSendSubmissionArgs = {
  input: SendSubmissionInput;
};


export type MutationSendVoteArgs = {
  input: SendVoteInput;
};


export type MutationStarScheduleItemArgs = {
  id: Scalars['ID'];
};


export type MutationSubscribeToNewsletterArgs = {
  input: SubscribeToNewsletterInput;
};


export type MutationUnstarScheduleItemArgs = {
  id: Scalars['ID'];
};


export type MutationUnsubscribeToNewsletterArgs = {
  input: UnsubscribeToNewsletterInput;
};


export type MutationUpdateAttendeeTicketArgs = {
  conference: Scalars['String'];
  input: UpdateAttendeeTicketInput;
  language?: Scalars['String'];
};


export type MutationUpdateBadgeScanArgs = {
  input: UpdateBadgeScanInput;
};


export type MutationUpdateGrantArgs = {
  input: UpdateGrantInput;
};


export type MutationUpdateOrCreateSlotItemArgs = {
  input: UpdateOrCreateSlotItemInput;
};


export type MutationUpdateParticipantArgs = {
  input: UpdateParticipantInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateScheduleInvitationArgs = {
  input: UpdateScheduleInvitationInput;
};


export type MutationUpdateSubmissionArgs = {
  input: UpdateSubmissionInput;
};

export type NewsArticle = {
  __typename?: 'NewsArticle';
  authorFullname: Scalars['String'];
  body: Scalars['String'];
  excerpt: Scalars['String'];
  id: Scalars['ID'];
  publishedAt: Scalars['DateTime'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type NewsGridSection = {
  __typename?: 'NewsGridSection';
  id: Scalars['ID'];
};

export type NewsletterSubscribeResult = {
  __typename?: 'NewsletterSubscribeResult';
  status: NewsletterSubscriptionResult;
};

export enum NewsletterSubscriptionResult {
  Subscribed = 'SUBSCRIBED',
  UnableToSubscribe = 'UNABLE_TO_SUBSCRIBE',
  WaitingConfirmation = 'WAITING_CONFIRMATION'
}

export type NoSubscription = {
  __typename?: 'NoSubscription';
  message: Scalars['String'];
};

export type NotSubscribedViaStripe = {
  __typename?: 'NotSubscribedViaStripe';
  message: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String'];
  id: Scalars['ID'];
  sentAt: Scalars['DateTime'];
  title: Scalars['String'];
};

export enum Occupation {
  Developer = 'developer',
  Other = 'other',
  Researcher = 'researcher',
  Student = 'student',
  Unemployed = 'unemployed'
}

export type OperationResult = {
  __typename?: 'OperationResult';
  ok: Scalars['Boolean'];
};

export type OperationSuccess = {
  __typename?: 'OperationSuccess';
  ok: Scalars['Boolean'];
};

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Page = {
  __typename?: 'Page';
  content: Scalars['String'];
  excerpt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type PageContentArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type PageSlugArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type PageTitleArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  pageSize: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type Participant = {
  __typename?: 'Participant';
  bio: Scalars['String'];
  facebookUrl: Scalars['String'];
  fullname: Scalars['String'];
  id: Scalars['ID'];
  instagramHandle: Scalars['String'];
  linkedinUrl: Scalars['String'];
  mastodonHandle: Scalars['String'];
  photo: Scalars['String'];
  previousTalkVideo?: Maybe<Scalars['String']>;
  publicProfile: Scalars['Boolean'];
  speakerLevel?: Maybe<Scalars['String']>;
  twitterHandle: Scalars['String'];
  userId: Scalars['ID'];
  website: Scalars['String'];
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Post = {
  __typename?: 'Post';
  author: BlogPostAuthor;
  content: Scalars['String'];
  excerpt: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  published: Scalars['DateTime'];
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type PostContentArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type PostExcerptArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type PostSlugArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type PostTitleArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type PretixOrder = {
  __typename?: 'PretixOrder';
  code: Scalars['String'];
  email: Scalars['String'];
  status: PretixOrderStatus;
  total: Scalars['String'];
  url: Scalars['String'];
};

export enum PretixOrderStatus {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type PriceCard = {
  __typename?: 'PriceCard';
  body: Scalars['String'];
  cta?: Maybe<Cta>;
  price: Scalars['String'];
  priceTier: Scalars['String'];
  title: Scalars['String'];
};

export type ProductVariation = {
  __typename?: 'ProductVariation';
  active: Scalars['Boolean'];
  defaultPrice: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  quantityLeft?: Maybe<Scalars['Int']>;
  soldOut?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  associationService: Scalars['Boolean'];
  badgeScan?: Maybe<BadgeScan>;
  badgeScans: BadgeScanPaginated;
  blogPost?: Maybe<Post>;
  blogPosts: Array<Post>;
  checklist: Array<ChecklistItem>;
  cmsPage?: Maybe<GenericPageSiteNotFoundError>;
  cmsPages: Array<GenericPage>;
  conference: Conference;
  conferenceRoleForTicketData: TicketDataConferenceRole;
  countries: Array<Country>;
  country: Country;
  jobListing?: Maybe<JobListing>;
  jobListings: Array<JobListing>;
  me: User;
  newsArticle?: Maybe<NewsArticle>;
  newsArticles: Array<NewsArticle>;
  notifications: Array<Notification>;
  order?: Maybe<PretixOrder>;
  page?: Maybe<Page>;
  pages: Array<Page>;
  participant?: Maybe<Participant>;
  scheduleInvitation?: Maybe<ScheduleInvitation>;
  submission?: Maybe<Submission>;
  submissionTags: Array<SubmissionTag>;
  submissions?: Maybe<SubmissionPaginated>;
  ticketIdToUserHashid?: Maybe<Scalars['String']>;
  votingTags: Array<SubmissionTag>;
};


export type QueryBadgeScanArgs = {
  id: Scalars['ID'];
};


export type QueryBadgeScansArgs = {
  conferenceCode: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: Scalars['Int'];
};


export type QueryBlogPostArgs = {
  slug: Scalars['String'];
};


export type QueryCmsPageArgs = {
  hostname: Scalars['String'];
  language: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryCmsPagesArgs = {
  hostname: Scalars['String'];
  language: Scalars['String'];
};


export type QueryConferenceArgs = {
  code: Scalars['String'];
};


export type QueryConferenceRoleForTicketDataArgs = {
  conferenceCode: Scalars['String'];
  rawTicketData: Scalars['String'];
};


export type QueryCountryArgs = {
  code?: Scalars['String'];
};


export type QueryJobListingArgs = {
  slug: Scalars['String'];
};


export type QueryJobListingsArgs = {
  conference: Scalars['String'];
};


export type QueryNewsArticleArgs = {
  hostname: Scalars['String'];
  language: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryNewsArticlesArgs = {
  hostname: Scalars['String'];
  language: Scalars['String'];
};


export type QueryOrderArgs = {
  code: Scalars['String'];
  conferenceCode: Scalars['String'];
};


export type QueryPageArgs = {
  code: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryPagesArgs = {
  code: Scalars['String'];
};


export type QueryParticipantArgs = {
  conference: Scalars['String'];
  userId: Scalars['ID'];
};


export type QueryScheduleInvitationArgs = {
  submissionId: Scalars['ID'];
};


export type QuerySubmissionArgs = {
  id: Scalars['ID'];
};


export type QuerySubmissionsArgs = {
  audienceLevels?: InputMaybe<Array<Scalars['String']>>;
  code: Scalars['String'];
  languages?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  types?: InputMaybe<Array<Scalars['String']>>;
  voted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTicketIdToUserHashidArgs = {
  conferenceCode: Scalars['String'];
  ticketId: Scalars['ID'];
};


export type QueryVotingTagsArgs = {
  conference: Scalars['String'];
};

export type Question = {
  __typename?: 'Question';
  answer?: Maybe<Answer>;
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  options?: Maybe<Array<Option>>;
  required?: Maybe<Scalars['Boolean']>;
};

export type RankRequest = {
  __typename?: 'RankRequest';
  isPublic: Scalars['Boolean'];
  rankedSubmissions: Array<RankSubmission>;
  stats: Array<RankStat>;
};

export type RankStat = {
  __typename?: 'RankStat';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['Int'];
};

export type RankSubmission = {
  __typename?: 'RankSubmission';
  rank: Scalars['Int'];
  score: Scalars['Decimal'];
  submission: Submission;
};

export type RegisterErrors = {
  __typename?: 'RegisterErrors';
  email?: Maybe<Array<FieldError>>;
  fullname?: Maybe<Array<FieldError>>;
  password?: Maybe<Array<FieldError>>;
};

export type RegisterInput = {
  email: Scalars['String'];
  fullname: Scalars['String'];
  password: Scalars['String'];
};

export type RegisterResult = EmailAlreadyUsed | RegisterSuccess | RegisterValidationError;

export type RegisterSuccess = {
  __typename?: 'RegisterSuccess';
  user: User;
};

export type RegisterValidationError = {
  __typename?: 'RegisterValidationError';
  errors: RegisterErrors;
};

export type RequestResetPasswordResult = OperationSuccess;

export type ResetPasswordErrors = {
  __typename?: 'ResetPasswordErrors';
  newPassword?: Maybe<Array<FieldError>>;
  token?: Maybe<Array<FieldError>>;
};

export type ResetPasswordInput = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
};

export type ResetPasswordResult = OperationSuccess | ResetPasswordTokenExpired | ResetPasswordTokenInvalid | ResetPasswordValidationError;

export type ResetPasswordTokenExpired = {
  __typename?: 'ResetPasswordTokenExpired';
  message: Scalars['String'];
};

export type ResetPasswordTokenInvalid = {
  __typename?: 'ResetPasswordTokenInvalid';
  message: Scalars['String'];
};

export type ResetPasswordValidationError = {
  __typename?: 'ResetPasswordValidationError';
  errors: ResetPasswordErrors;
};

export type Room = {
  __typename?: 'Room';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ScanBadgeInput = {
  conferenceCode: Scalars['String'];
  url: Scalars['String'];
};

export type ScanError = {
  __typename?: 'ScanError';
  message: Scalars['String'];
};

export type ScheduleInvitation = {
  __typename?: 'ScheduleInvitation';
  dates: Array<ScheduleInvitationDate>;
  id: Scalars['ID'];
  notes: Scalars['String'];
  option: ScheduleInvitationOption;
  submission: Submission;
  title: Scalars['String'];
};

export type ScheduleInvitationDate = {
  __typename?: 'ScheduleInvitationDate';
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  start: Scalars['DateTime'];
};

export type ScheduleInvitationNotFound = {
  __typename?: 'ScheduleInvitationNotFound';
  message: Scalars['String'];
};

export type ScheduleInvitationNotFoundScheduleInvitation = ScheduleInvitation | ScheduleInvitationNotFound;

export enum ScheduleInvitationOption {
  CantAttend = 'CANT_ATTEND',
  Confirm = 'CONFIRM',
  Maybe = 'MAYBE',
  NoAnswer = 'NO_ANSWER',
  Reject = 'REJECT'
}

export type ScheduleItem = {
  __typename?: 'ScheduleItem';
  audienceLevel?: Maybe<AudienceLevel>;
  conference: Conference;
  description: Scalars['String'];
  duration?: Maybe<Scalars['Int']>;
  end: Scalars['DateTime'];
  hasLimitedCapacity: Scalars['Boolean'];
  hasSpacesLeft: Scalars['Boolean'];
  highlightColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  keynote?: Maybe<Keynote>;
  language: Language;
  rooms: Array<Room>;
  slidoUrl: Scalars['String'];
  slug: Scalars['String'];
  spacesLeft: Scalars['Int'];
  speakers: Array<ScheduleItemUser>;
  start: Scalars['DateTime'];
  status: Scalars['String'];
  submission?: Maybe<Submission>;
  title: Scalars['String'];
  type: Scalars['String'];
  userHasSpot: Scalars['Boolean'];
  youtubeVideoId?: Maybe<Scalars['String']>;
};

export type ScheduleItemIsFull = {
  __typename?: 'ScheduleItemIsFull';
  message: Scalars['String'];
};

export type ScheduleItemNotBookable = {
  __typename?: 'ScheduleItemNotBookable';
  message: Scalars['String'];
};

export type ScheduleItemUser = {
  __typename?: 'ScheduleItemUser';
  fullName: Scalars['String'];
  id: Scalars['ID'];
  participant?: Maybe<Participant>;
};

export type SchedulePreviewSection = {
  __typename?: 'SchedulePreviewSection';
  id: Scalars['ID'];
  primaryCta?: Maybe<Cta>;
  secondaryCta?: Maybe<Cta>;
  title: Scalars['String'];
};

export type ScheduleSlot = {
  __typename?: 'ScheduleSlot';
  duration: Scalars['Int'];
  endHour: Scalars['Time'];
  hour: Scalars['Time'];
  id: Scalars['ID'];
  isLive: Scalars['Boolean'];
  items: Array<ScheduleItem>;
  type: ScheduleSlotType;
};

export enum ScheduleSlotType {
  Default = 'DEFAULT',
  FreeTime = 'FREE_TIME'
}

export type SendGrantInput = {
  ageGroup: AgeGroup;
  beenToOtherEvents: Scalars['String'];
  conference: Scalars['ID'];
  fullName: Scalars['String'];
  gender: Scalars['String'];
  grantType: GrantType;
  interestedInVolunteering: InterestedInVolunteering;
  name: Scalars['String'];
  needsFundsForTravel: Scalars['Boolean'];
  notes: Scalars['String'];
  occupation: Occupation;
  pythonUsage: Scalars['String'];
  travellingFrom: Scalars['String'];
  why: Scalars['String'];
};

export type SendGrantReplyError = {
  __typename?: 'SendGrantReplyError';
  message: Scalars['String'];
};

export type SendGrantReplyInput = {
  instance: Scalars['ID'];
  message: Scalars['String'];
  status?: InputMaybe<StatusOption>;
};

export type SendGrantReplyResult = Grant | SendGrantReplyError;

export type SendGrantResult = Grant | GrantErrors;

export type SendSubmissionErrors = {
  __typename?: 'SendSubmissionErrors';
  abstract: Array<Scalars['String']>;
  audienceLevel: Array<Scalars['String']>;
  conference: Array<Scalars['String']>;
  duration: Array<Scalars['String']>;
  elevatorPitch: Array<Scalars['String']>;
  instance: Array<Scalars['String']>;
  languages: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
  notes: Array<Scalars['String']>;
  previousTalkVideo: Array<Scalars['String']>;
  shortSocialSummary: Array<Scalars['String']>;
  speakerBio: Array<Scalars['String']>;
  speakerFacebookUrl: Array<Scalars['String']>;
  speakerInstagramHandle: Array<Scalars['String']>;
  speakerLevel: Array<Scalars['String']>;
  speakerLinkedinUrl: Array<Scalars['String']>;
  speakerMastodonHandle: Array<Scalars['String']>;
  speakerPhoto: Array<Scalars['String']>;
  speakerTwitterHandle: Array<Scalars['String']>;
  speakerWebsite: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  title: Array<Scalars['String']>;
  topic: Array<Scalars['String']>;
  type: Array<Scalars['String']>;
};

export type SendSubmissionInput = {
  abstract: MultiLingualInput;
  audienceLevel: Scalars['ID'];
  conference: Scalars['ID'];
  duration: Scalars['ID'];
  elevatorPitch: MultiLingualInput;
  languages: Array<Scalars['ID']>;
  notes: Scalars['String'];
  previousTalkVideo: Scalars['String'];
  shortSocialSummary: Scalars['String'];
  speakerBio: Scalars['String'];
  speakerFacebookUrl: Scalars['String'];
  speakerInstagramHandle: Scalars['String'];
  speakerLevel: Scalars['String'];
  speakerLinkedinUrl: Scalars['String'];
  speakerMastodonHandle: Scalars['String'];
  speakerPhoto: Scalars['String'];
  speakerTwitterHandle: Scalars['String'];
  speakerWebsite: Scalars['String'];
  tags?: Array<Scalars['ID']>;
  title: MultiLingualInput;
  topic?: InputMaybe<Scalars['ID']>;
  type: Scalars['ID'];
};

export type SendSubmissionOutput = SendSubmissionErrors | Submission;

export type SendVoteErrors = {
  __typename?: 'SendVoteErrors';
  nonFieldErrors: Array<Scalars['String']>;
  submission: Array<Scalars['String']>;
  value: Array<Scalars['String']>;
};

export type SendVoteInput = {
  submission: Scalars['ID'];
  value: Scalars['Int'];
};

/** Output */
export type SendVoteOutput = SendVoteErrors | VoteType;

export type SimpleTextCard = {
  __typename?: 'SimpleTextCard';
  body: Scalars['String'];
  cta?: Maybe<Cta>;
  title: Scalars['String'];
};

export type SiteNotFoundError = {
  __typename?: 'SiteNotFoundError';
  message: Scalars['String'];
};

export type SliderCardsSection = {
  __typename?: 'SliderCardsSection';
  cards: Array<AvailableCards>;
  id: Scalars['ID'];
  snakeBackground: Scalars['Boolean'];
  spacing: Spacing;
  title: Scalars['String'];
};

export type SocialsSection = {
  __typename?: 'SocialsSection';
  hashtag: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
};

export enum Spacing {
  Xl = 'XL',
  '3Xl' = '_3XL'
}

export type SpecialGuestSection = {
  __typename?: 'SpecialGuestSection';
  cta?: Maybe<Cta>;
  eventDate: Scalars['Date'];
  guestJobTitle: Scalars['String'];
  guestName: Scalars['String'];
  guestPhoto: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type Sponsor = {
  __typename?: 'Sponsor';
  id: Scalars['ID'];
  image: Scalars['String'];
  link: Scalars['String'];
  name: Scalars['String'];
};

export type SponsorsByLevel = {
  __typename?: 'SponsorsByLevel';
  highlightColor?: Maybe<Scalars['String']>;
  level: Scalars['String'];
  sponsors: Array<Sponsor>;
};

export type SponsorsSection = {
  __typename?: 'SponsorsSection';
  body: Scalars['String'];
  cta?: Maybe<Cta>;
  id: Scalars['ID'];
  layout: SponsorsSectionLayout;
  title: Scalars['String'];
};

export enum SponsorsSectionLayout {
  SideBySide = 'SIDE_BY_SIDE',
  Vertical = 'VERTICAL'
}

export enum Status {
  Approved = 'approved',
  Confirmed = 'confirmed',
  Pending = 'pending',
  Refused = 'refused',
  Rejected = 'rejected',
  WaitingForConfirmation = 'waiting_for_confirmation',
  WaitingList = 'waiting_list',
  WaitingListMaybe = 'waiting_list_maybe'
}

export enum StatusOption {
  Confirmed = 'confirmed',
  NeedInfo = 'need_info',
  Refused = 'refused'
}

export type Submission = {
  __typename?: 'Submission';
  abstract?: Maybe<Scalars['String']>;
  audienceLevel?: Maybe<AudienceLevel>;
  canEdit: Scalars['Boolean'];
  conference: Conference;
  duration?: Maybe<Duration>;
  elevatorPitch?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  languages?: Maybe<Array<Language>>;
  multilingualAbstract?: Maybe<MultiLingualString>;
  multilingualElevatorPitch?: Maybe<MultiLingualString>;
  multilingualTitle?: Maybe<MultiLingualString>;
  myVote?: Maybe<VoteType>;
  notes?: Maybe<Scalars['String']>;
  previousTalkVideo?: Maybe<Scalars['String']>;
  scheduleItems: Array<ScheduleItem>;
  shortSocialSummary?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  speaker?: Maybe<SubmissionSpeaker>;
  speakerLevel?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tags?: Maybe<Array<SubmissionTag>>;
  title: Scalars['String'];
  topic?: Maybe<Topic>;
  type?: Maybe<SubmissionType>;
};


export type SubmissionAbstractArgs = {
  language: Scalars['String'];
};


export type SubmissionElevatorPitchArgs = {
  language: Scalars['String'];
};


export type SubmissionTitleArgs = {
  language: Scalars['String'];
};

export type SubmissionPaginated = {
  __typename?: 'SubmissionPaginated';
  items: Array<Submission>;
  pageInfo: PageInfo;
};

export type SubmissionSpeaker = {
  __typename?: 'SubmissionSpeaker';
  fullName: Scalars['String'];
  gender: Scalars['String'];
  id: Scalars['ID'];
};

export type SubmissionTag = {
  __typename?: 'SubmissionTag';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SubmissionType = {
  __typename?: 'SubmissionType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SubscribeToNewsletterErrors = {
  __typename?: 'SubscribeToNewsletterErrors';
  email: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type SubscribeToNewsletterInput = {
  email: Scalars['String'];
};

/** Output */
export type SubscribeToNewsletterOutput = NewsletterSubscribeResult | SubscribeToNewsletterErrors;

export type SubscribeUserResult = AlreadySubscribed | CheckoutSession;

export type TextSection = {
  __typename?: 'TextSection';
  accordions: Array<Accordion>;
  body: Scalars['String'];
  bodyTextSize: BodyTextSize;
  cta?: Maybe<Cta>;
  id: Scalars['ID'];
  illustration: Scalars['String'];
  isMainTitle: Scalars['Boolean'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type TicketDataConferenceRole = {
  __typename?: 'TicketDataConferenceRole';
  role: ConferenceRole;
  ticketHashid: Scalars['String'];
};

export type TicketItem = {
  __typename?: 'TicketItem';
  active?: Maybe<Scalars['Boolean']>;
  admission: Scalars['Boolean'];
  availableFrom?: Maybe<Scalars['String']>;
  availableUntil?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryInternalName?: Maybe<Scalars['String']>;
  defaultPrice?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantityLeft?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<Question>>;
  soldOut?: Maybe<Scalars['Boolean']>;
  taxRate?: Maybe<Scalars['Float']>;
  type?: Maybe<TicketType>;
  variations?: Maybe<Array<ProductVariation>>;
};

export type TicketReassigned = {
  __typename?: 'TicketReassigned';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum TicketType {
  Association = 'ASSOCIATION',
  Business = 'BUSINESS',
  Hotel = 'HOTEL',
  SocialEvent = 'SOCIAL_EVENT',
  Standard = 'STANDARD'
}

export type Topic = {
  __typename?: 'Topic';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UnsubscribeToNewsletterErrors = {
  __typename?: 'UnsubscribeToNewsletterErrors';
  email: Array<Scalars['String']>;
  nonFieldErrors: Array<Scalars['String']>;
};

export type UnsubscribeToNewsletterInput = {
  email: Scalars['String'];
};

/** Output */
export type UnsubscribeToNewsletterOutput = OperationResult | UnsubscribeToNewsletterErrors;

export type UpdateAttendeeTicketError = {
  __typename?: 'UpdateAttendeeTicketError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type UpdateAttendeeTicketErrors = {
  __typename?: 'UpdateAttendeeTicketErrors';
  errors: Array<UpdateAttendeeTicketError>;
  id: Scalars['ID'];
};

export type UpdateAttendeeTicketInput = {
  answers?: InputMaybe<Array<AnswerInput>>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateAttendeeTicketResult = AttendeeTicket | TicketReassigned | UpdateAttendeeTicketErrors;

export type UpdateBadgeScanInput = {
  id: Scalars['String'];
  notes: Scalars['String'];
};

export type UpdateGrantInput = {
  ageGroup: AgeGroup;
  beenToOtherEvents: Scalars['String'];
  conference: Scalars['ID'];
  fullName: Scalars['String'];
  gender: Scalars['String'];
  grantType: GrantType;
  instance: Scalars['ID'];
  interestedInVolunteering: InterestedInVolunteering;
  name: Scalars['String'];
  needsFundsForTravel: Scalars['Boolean'];
  notes: Scalars['String'];
  occupation: Occupation;
  pythonUsage: Scalars['String'];
  travellingFrom: Scalars['String'];
  why: Scalars['String'];
};

export type UpdateGrantResult = Grant | GrantErrors;

export type UpdateOrCreateSlotItemError = {
  __typename?: 'UpdateOrCreateSlotItemError';
  message: Scalars['String'];
};

export type UpdateOrCreateSlotItemErrorUpdateOrCreateSlotItemResult = UpdateOrCreateSlotItemError | UpdateOrCreateSlotItemResult;

export type UpdateOrCreateSlotItemInput = {
  itemId?: InputMaybe<Scalars['ID']>;
  keynoteId?: InputMaybe<Scalars['ID']>;
  rooms: Array<Scalars['ID']>;
  slotId: Scalars['ID'];
  submissionId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrCreateSlotItemResult = {
  __typename?: 'UpdateOrCreateSlotItemResult';
  updatedSlots: Array<ScheduleSlot>;
};

export type UpdateParticipantErrors = {
  __typename?: 'UpdateParticipantErrors';
  bio: Array<Scalars['String']>;
  facebookUrl: Array<Scalars['String']>;
  instagramHandle: Array<Scalars['String']>;
  level: Array<Scalars['String']>;
  linkedinUrl: Array<Scalars['String']>;
  mastodonHandle: Array<Scalars['String']>;
  photo: Array<Scalars['String']>;
  twitterHandle: Array<Scalars['String']>;
  website: Array<Scalars['String']>;
};

export type UpdateParticipantInput = {
  bio: Scalars['String'];
  conference: Scalars['String'];
  facebookUrl: Scalars['String'];
  instagramHandle: Scalars['String'];
  linkedinUrl: Scalars['String'];
  mastodonHandle: Scalars['String'];
  photo: Scalars['String'];
  previousTalkVideo: Scalars['String'];
  publicProfile: Scalars['Boolean'];
  speakerLevel: Scalars['String'];
  twitterHandle: Scalars['String'];
  website: Scalars['String'];
};

export type UpdateParticipantResult = Participant | UpdateParticipantValidationError;

export type UpdateParticipantValidationError = {
  __typename?: 'UpdateParticipantValidationError';
  errors: UpdateParticipantErrors;
};

export type UpdateProfileErrors = {
  __typename?: 'UpdateProfileErrors';
  country?: Maybe<Array<FieldError>>;
  dateBirth?: Maybe<Array<FieldError>>;
  fullName?: Maybe<Array<FieldError>>;
  gender?: Maybe<Array<FieldError>>;
  name?: Maybe<Array<FieldError>>;
  openToNewsletter?: Maybe<Array<FieldError>>;
  openToRecruiting?: Maybe<Array<FieldError>>;
};

export type UpdateProfileInput = {
  country: Scalars['String'];
  dateBirth?: InputMaybe<Scalars['Date']>;
  fullName: Scalars['String'];
  gender: Scalars['String'];
  name: Scalars['String'];
  openToNewsletter: Scalars['Boolean'];
  openToRecruiting: Scalars['Boolean'];
};

export type UpdateProfileResult = UpdateProfileValidationError | User;

export type UpdateProfileValidationError = {
  __typename?: 'UpdateProfileValidationError';
  errors: UpdateProfileErrors;
};

export type UpdateScheduleInvitationInput = {
  notes: Scalars['String'];
  option: ScheduleInvitationOption;
  submissionId: Scalars['ID'];
};

export type UpdateSubmissionInput = {
  abstract: MultiLingualInput;
  audienceLevel: Scalars['ID'];
  duration: Scalars['ID'];
  elevatorPitch: MultiLingualInput;
  instance: Scalars['ID'];
  languages: Array<Scalars['ID']>;
  notes: Scalars['String'];
  previousTalkVideo: Scalars['String'];
  shortSocialSummary: Scalars['String'];
  speakerBio: Scalars['String'];
  speakerFacebookUrl: Scalars['String'];
  speakerInstagramHandle: Scalars['String'];
  speakerLevel: Scalars['String'];
  speakerLinkedinUrl: Scalars['String'];
  speakerMastodonHandle: Scalars['String'];
  speakerPhoto: Scalars['String'];
  speakerTwitterHandle: Scalars['String'];
  speakerWebsite: Scalars['String'];
  tags?: Array<Scalars['ID']>;
  title: MultiLingualInput;
  topic?: InputMaybe<Scalars['ID']>;
  type: Scalars['ID'];
};

export type UpdateSubmissionOutput = SendSubmissionErrors | Submission;

export type User = {
  __typename?: 'User';
  canEditSchedule: Scalars['Boolean'];
  conferenceRoles: Array<ConferenceRole>;
  country: Scalars['String'];
  dateBirth?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  fullname: Scalars['String'];
  gender: Scalars['String'];
  grant?: Maybe<Grant>;
  hashid: Scalars['String'];
  id: Scalars['ID'];
  isPythonItaliaMember: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  name: Scalars['String'];
  openToNewsletter: Scalars['Boolean'];
  openToRecruiting: Scalars['Boolean'];
  orders: Array<PretixOrder>;
  participant?: Maybe<Participant>;
  starredScheduleItems: Array<Scalars['ID']>;
  submissions: Array<Submission>;
  tickets: Array<AttendeeTicket>;
  username: Scalars['String'];
};


export type UserConferenceRolesArgs = {
  conferenceCode: Scalars['String'];
};


export type UserGrantArgs = {
  conference: Scalars['String'];
};


export type UserOrdersArgs = {
  conference: Scalars['String'];
};


export type UserParticipantArgs = {
  conference: Scalars['String'];
};


export type UserStarredScheduleItemsArgs = {
  conference: Scalars['String'];
};


export type UserSubmissionsArgs = {
  conference: Scalars['String'];
};


export type UserTicketsArgs = {
  conference: Scalars['String'];
  language: Scalars['String'];
};

export type UserIsAlreadyBooked = {
  __typename?: 'UserIsAlreadyBooked';
  message: Scalars['String'];
};

export type UserIsNotBooked = {
  __typename?: 'UserIsNotBooked';
  message: Scalars['String'];
};

export type UserNeedsConferenceTicket = {
  __typename?: 'UserNeedsConferenceTicket';
  message: Scalars['String'];
};

export type VoteType = {
  __typename?: 'VoteType';
  id: Scalars['ID'];
  submission: Submission;
  value: Scalars['Int'];
};

export type Voucher = {
  __typename?: 'Voucher';
  allItems: Scalars['Boolean'];
  code: Scalars['String'];
  id: Scalars['ID'];
  items: Array<Scalars['ID']>;
  maxUsages: Scalars['Int'];
  priceMode: Scalars['String'];
  redeemed: Scalars['Int'];
  validUntil?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
  variationId?: Maybe<Scalars['ID']>;
};

export type WrongEmailOrPassword = {
  __typename?: 'WrongEmailOrPassword';
  message: Scalars['String'];
};

export type CheckoutSectionQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type CheckoutSectionQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, start: any, end: any, pretixEventUrl: string, timeZone: string, tickets: Array<{ __typename?: 'TicketItem', id: string, language?: string | null, name: string, description?: string | null, defaultPrice?: string | null, availableUntil?: string | null, quantityLeft?: number | null, soldOut?: boolean | null, type?: TicketType | null, category?: string | null, categoryInternalName?: string | null, taxRate?: number | null, admission: boolean, variations?: Array<{ __typename?: 'ProductVariation', id: string, defaultPrice: string, value: string, soldOut?: boolean | null, active: boolean, description: string }> | null, questions?: Array<{ __typename?: 'Question', id: string, name: string, required?: boolean | null, hidden: boolean, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null }> | null }>, hotelRooms: Array<{ __typename?: 'HotelRoom', id: string, name: string, description: string, price: string, isSoldOut: boolean, capacityLeft: number, checkInDates: Array<string>, checkOutDates: Array<string>, availableBedLayouts: Array<{ __typename?: 'BedLayout', id: string, name: string }> }> } };

export type InformationSectionQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type InformationSectionQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, cfp?: { __typename?: 'Deadline', id: string, start: any, end: any } | null, voting?: { __typename?: 'Deadline', id: string, start: any, end: any } | null, grants?: { __typename?: 'Deadline', id: string, start: any, end: any } | null } };

export type KeynotesSectionQueryVariables = Exact<{
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynotesSectionQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, keynotes: Array<{ __typename?: 'Keynote', id: string, title: string, slug: string, start?: any | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string, participant?: { __typename?: 'Participant', id: string, photo: string, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string } | null }> }> } };

export type LiveStreamingSectionQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type LiveStreamingSectionQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, timezone: string, currentDay?: { __typename?: 'Day', day: any, runningEvents: Array<{ __typename?: 'ScheduleItem', id: string, slidoUrl: string, duration?: number | null, title: string, type: string, rooms: Array<{ __typename?: 'Room', id: string, name: string }> }>, rooms: Array<{ __typename?: 'DayRoom', id: string, name: string, type: string, streamingUrl: string, slidoUrl: string }> } | null } };

export type NewsGridSectionQueryVariables = Exact<{
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type NewsGridSectionQuery = { __typename?: 'Query', newsArticles: Array<{ __typename?: 'NewsArticle', id: string, slug: string, title: string, publishedAt: any }>, blogPosts: Array<{ __typename?: 'Post', id: string, slug: string, title: string, excerpt: string, published: any, author: { __typename?: 'BlogPostAuthor', fullName: string } }> };

export type SchedulePreviewSectionQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SchedulePreviewSectionQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, days: Array<{ __typename?: 'Day', day: any, randomEvents: Array<{ __typename?: 'ScheduleItem', id: string, title: string, slug: string, start: any, end: any, submission?: { __typename?: 'Submission', id: string, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, language: { __typename?: 'Language', id: string, name: string }, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string, participant?: { __typename?: 'Participant', id: string, photo: string } | null }> }> }> } };

export type SponsorsSectionQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SponsorsSectionQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, sponsorsByLevel: Array<{ __typename?: 'SponsorsByLevel', name: string, sponsors: Array<{ __typename?: 'Sponsor', id: string, name: string, url: string, logo: string }> }> } };

export type CfpFormQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type CfpFormQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, durations: Array<{ __typename?: 'Duration', name: string, id: string, allowedSubmissionTypes: Array<{ __typename?: 'SubmissionType', id: string, name: string }> }>, audienceLevels: Array<{ __typename?: 'AudienceLevel', id: string, name: string }>, submissionTypes: Array<{ __typename?: 'SubmissionType', id: string, name: string }>, languages: Array<{ __typename?: 'Language', code: string, id: string, name: string }> } };

export type ParticipantDataQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type ParticipantDataQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, participant?: { __typename?: 'Participant', id: string, photo: string, bio: string, website: string, speakerLevel?: string | null, previousTalkVideo?: string | null, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string } | null } };

export type SendSubmissionMutationVariables = Exact<{
  input: SendSubmissionInput;
  language: Scalars['String'];
}>;


export type SendSubmissionMutation = { __typename?: 'Mutation', mutationOp: { __typename: 'SendSubmissionErrors', nonFieldErrors: Array<string>, validationTitle: Array<string>, validationAbstract: Array<string>, validationLanguages: Array<string>, validationType: Array<string>, validationDuration: Array<string>, validationElevatorPitch: Array<string>, validationNotes: Array<string>, validationAudienceLevel: Array<string>, validationTags: Array<string>, validationPreviousTalkVideo: Array<string>, validationSpeakerLevel: Array<string>, validationShortSocialSummary: Array<string>, validationSpeakerBio: Array<string>, validationSpeakerWebsite: Array<string>, validationSpeakerPhoto: Array<string>, validationSpeakerTwitterHandle: Array<string>, validationSpeakerInstagramHandle: Array<string>, validationSpeakerLinkedinUrl: Array<string>, validationSpeakerFacebookUrl: Array<string> } | { __typename: 'Submission', id: string, title: string } };

export type MyEditProfileQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type MyEditProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, hashid: string, email: string, name: string, fullName: string, gender: string, openToRecruiting: boolean, openToNewsletter: boolean, dateBirth?: any | null, country: string, participant?: { __typename?: 'Participant', id: string, publicProfile: boolean, photo: string, bio: string, website: string, speakerLevel?: string | null, previousTalkVideo?: string | null, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string } | null } };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
  updateParticipantInput: UpdateParticipantInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename: 'UpdateProfileValidationError', errors: { __typename?: 'UpdateProfileErrors', name?: Array<{ __typename?: 'FieldError', message: string }> | null, dateBirth?: Array<{ __typename?: 'FieldError', message: string }> | null, fullName?: Array<{ __typename?: 'FieldError', message: string }> | null, gender?: Array<{ __typename?: 'FieldError', message: string }> | null, openToRecruiting?: Array<{ __typename?: 'FieldError', message: string }> | null, openToNewsletter?: Array<{ __typename?: 'FieldError', message: string }> | null, country?: Array<{ __typename?: 'FieldError', message: string }> | null } } | { __typename: 'User', id: string, name: string, fullName: string, gender: string, openToRecruiting: boolean, openToNewsletter: boolean, country: string, dateBirth?: any | null }, updateParticipant: { __typename: 'Participant', id: string, bio: string, website: string, photo: string, publicProfile: boolean, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string } | { __typename: 'UpdateParticipantValidationError', errors: { __typename?: 'UpdateParticipantErrors', bio: Array<string>, website: Array<string>, photo: Array<string>, twitterHandle: Array<string>, instagramHandle: Array<string>, linkedinUrl: Array<string>, facebookUrl: Array<string>, mastodonHandle: Array<string> } } };

export type GenerateParticipantAvatarUploadUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateParticipantAvatarUploadUrlMutation = { __typename?: 'Mutation', generateParticipantAvatarUploadUrl: { __typename?: 'AvatarUploadUrl', uploadUrl: string, fileUrl: string } };

export type FooterQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type FooterQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, footerEn?: { __typename?: 'Menu', links: Array<{ __typename?: 'MenuLink', text: string, link: string }> } | null, footerIt?: { __typename?: 'Menu', links: Array<{ __typename?: 'MenuLink', text: string, link: string }> } | null } };

export type GrantDeadlineQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type GrantDeadlineQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, deadline?: { __typename?: 'Deadline', id: string, start: any, end: any, status: DeadlineStatus } | null } };

export type SendGrantMutationVariables = Exact<{
  input: SendGrantInput;
}>;


export type SendGrantMutation = { __typename?: 'Mutation', mutationOp: { __typename: 'Grant', id: string } | { __typename: 'GrantErrors', nonFieldErrors: Array<string>, validationConference: Array<string>, validationName: Array<string>, validationFullName: Array<string>, validationGender: Array<string>, validationGrantType: Array<string>, validationOccupation: Array<string>, validationAgeGroup: Array<string>, validationPythonUsage: Array<string>, validationBeenToOtherEvents: Array<string>, validationInterestedInVolunteering: Array<string>, validationNeedsFundsForTravel: Array<string>, validationWhy: Array<string>, validationNotes: Array<string>, validationTravellingFrom: Array<string> } };

export type HeaderQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type HeaderQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, isRunning: boolean, currentDay?: { __typename?: 'Day', day: any, rooms: Array<{ __typename?: 'DayRoom', id: string, streamingUrl: string }> } | null, conferenceMenuEn?: { __typename?: 'Menu', links: Array<{ __typename?: 'MenuLink', text: string, link: string, page?: { __typename?: 'Page', slug: string } | null }> } | null, programMenuEn?: { __typename?: 'Menu', links: Array<{ __typename?: 'MenuLink', text: string, link: string, page?: { __typename?: 'Page', slug: string } | null }> } | null, conferenceMenuIt?: { __typename?: 'Menu', links: Array<{ __typename?: 'MenuLink', text: string, link: string, page?: { __typename?: 'Page', slug: string } | null }> } | null, programMenuIt?: { __typename?: 'Menu', links: Array<{ __typename?: 'MenuLink', text: string, link: string, page?: { __typename?: 'Page', slug: string } | null }> } | null } };

export type IndexPageQueryVariables = Exact<{
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type IndexPageQuery = { __typename?: 'Query', cmsPage?: { __typename?: 'GenericPage', id: string, title: string, body: Array<{ __typename?: 'CMSMap', id: string, latitude: any, longitude: any, link: string, image: string } | { __typename?: 'CheckoutSection', id: string, visibleCategories: Array<CheckoutCategory> } | { __typename?: 'HomeIntroSection', id: string, pretitle: string, title: string } | { __typename?: 'InformationSection', id: string, title: string, body: string, backgroundColor: string, illustration: string, countdownToDatetime?: any | null, countdownToDeadline?: string | null, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'KeynotersSection', id: string, title: string, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'LiveStreamingSection' } | { __typename?: 'NewsGridSection', id: string } | { __typename?: 'SchedulePreviewSection', id: string, title: string, primaryCta?: { __typename?: 'CTA', label: string, link: string } | null, secondaryCta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'SliderCardsSection', id: string, title: string, spacing: Spacing, snakeBackground: boolean, cards: Array<{ __typename?: 'PriceCard', title: string, body: string, price: string, priceTier: string, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'SimpleTextCard', title: string, body: string, cta?: { __typename?: 'CTA', label: string, link: string } | null }> } | { __typename?: 'SocialsSection', id: string, label: string, hashtag: string } | { __typename?: 'SpecialGuestSection', id: string, title: string, guestName: string, guestJobTitle: string, guestPhoto: string, eventDate: any, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'SponsorsSection', id: string, title: string, body: string, layout: SponsorsSectionLayout, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'TextSection', id: string, body: string, bodyTextSize: BodyTextSize, illustration: string, subtitle: string, title: string, isMainTitle: boolean, accordions: Array<{ __typename?: 'Accordion', title: string, body: string, isOpen: boolean }>, cta?: { __typename?: 'CTA', label: string, link: string } | null }> } | { __typename?: 'SiteNotFoundError' } | null, conference: { __typename?: 'Conference', id: string, name: string, introduction: string, isRunning: boolean } };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', submissionTags: Array<{ __typename?: 'SubmissionTag', name: string, id: string }> };

export type AllJobListingsQueryVariables = Exact<{
  language: Scalars['String'];
  conference: Scalars['String'];
}>;


export type AllJobListingsQuery = { __typename?: 'Query', jobListings: Array<{ __typename?: 'JobListing', id: string, slug: string, title: string, description: string, applyUrl: string, company: string, companyLogo?: string | null }> };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename: 'LoginSuccess', user: { __typename?: 'User', id: string } } | { __typename: 'LoginValidationError', errors: { __typename?: 'LoginErrors', email?: Array<{ __typename?: 'FieldError', message: string, type: string }> | null, password?: Array<{ __typename?: 'FieldError', message: string, type: string }> | null } } | { __typename: 'WrongEmailOrPassword' } };

export type MyProfileWithOrdersQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type MyProfileWithOrdersQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, orders: Array<{ __typename?: 'PretixOrder', code: string, status: PretixOrderStatus, url: string, total: string }> } };

export type BadgeScansQueryVariables = Exact<{
  conferenceCode: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize: Scalars['Int'];
}>;


export type BadgeScansQuery = { __typename?: 'Query', badgeScans: { __typename?: 'BadgeScanPaginated', pageInfo: { __typename?: 'PageInfo', pageSize: number, totalItems: number, totalPages: number }, items: Array<{ __typename?: 'BadgeScan', id: string, created: any, notes: string, attendee: { __typename?: 'Attendee', email: string, fullName: string } }> } };

export type ExportBadgeScansMutationVariables = Exact<{
  conferenceCode: Scalars['String'];
}>;


export type ExportBadgeScansMutation = { __typename?: 'Mutation', exportBadgeScans: { __typename?: 'BadgeScanExport', id: string, url: string } };

export type MyProfileWithSubmissionsQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type MyProfileWithSubmissionsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, fullName: string, email: string, submissions: Array<{ __typename?: 'Submission', id: string, title: string, status: string, scheduleItems: Array<{ __typename?: 'ScheduleItem', id: string, start: any, end: any, status: string }>, type?: { __typename?: 'SubmissionType', id: string, name: string } | null }> }, conference: { __typename?: 'Conference', id: string, deadline?: { __typename?: 'Deadline', id: string, status: DeadlineStatus } | null } };

export type MyProfileWithTicketsQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type MyProfileWithTicketsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, fullName: string, email: string, tickets: Array<{ __typename?: 'AttendeeTicket', id: string, hashid: string, name?: string | null, email?: string | null, secret: string, variation?: string | null, role?: ConferenceRole | null, item: { __typename?: 'TicketItem', id: string, name: string, language?: string | null, description?: string | null, category?: string | null, admission: boolean, variations?: Array<{ __typename?: 'ProductVariation', id: string, value: string }> | null, questions?: Array<{ __typename?: 'Question', id: string, hidden: boolean, name: string, answer?: { __typename?: 'Answer', answer: string, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null }> | null } }> } };

export type UpdateTicketMutationVariables = Exact<{
  conference: Scalars['String'];
  input: UpdateAttendeeTicketInput;
  language: Scalars['String'];
}>;


export type UpdateTicketMutation = { __typename: 'Mutation', updateAttendeeTicket: { __typename: 'AttendeeTicket', id: string, name?: string | null, email?: string | null, item: { __typename?: 'TicketItem', id: string, name: string, language?: string | null, description?: string | null, category?: string | null, questions?: Array<{ __typename?: 'Question', id: string, name: string, answer?: { __typename?: 'Answer', answer: string, options?: Array<string> | null } | null, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null }> | null } } | { __typename: 'TicketReassigned', id: string, email?: string | null } | { __typename: 'UpdateAttendeeTicketErrors', id: string, errors: Array<{ __typename?: 'UpdateAttendeeTicketError', field: string, message: string }> } };

export type SubscribeMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SubscribeMutation = { __typename?: 'Mutation', subscribeToNewsletter: { __typename: 'NewsletterSubscribeResult', status: NewsletterSubscriptionResult } | { __typename: 'SubscribeToNewsletterErrors', nonFieldErrors: Array<string>, validationEmail: Array<string> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: string };

export type MyProfileQueryVariables = Exact<{
  conferenceCode: Scalars['String'];
}>;


export type MyProfileQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, fullName: string, conferenceRoles: Array<ConferenceRole> } };

export type MyGrantQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type MyGrantQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, grant?: { __typename?: 'Grant', id: string, status: Status, fullName: string, name: string, gender: string, grantType: GrantType, occupation: Occupation, ageGroup?: AgeGroup | null, pythonUsage: string, beenToOtherEvents: string, interestedInVolunteering: InterestedInVolunteering, needsFundsForTravel: boolean, why: string, notes: string, travellingFrom: string } | null } };

export type ParticipantPublicProfileQueryVariables = Exact<{
  userId: Scalars['ID'];
  conference: Scalars['String'];
}>;


export type ParticipantPublicProfileQuery = { __typename?: 'Query', participant?: { __typename?: 'Participant', id: string, fullname: string, publicProfile: boolean, bio: string, website: string, photo: string, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestResetPassword: { __typename: 'OperationSuccess', ok: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename: 'OperationSuccess', ok: boolean } | { __typename: 'ResetPasswordTokenExpired' } | { __typename: 'ResetPasswordTokenInvalid' } | { __typename: 'ResetPasswordValidationError', errors: { __typename?: 'ResetPasswordErrors', token?: Array<{ __typename?: 'FieldError', message: string }> | null, newPassword?: Array<{ __typename?: 'FieldError', message: string }> | null } } };

export type BookScheduleItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookScheduleItemMutation = { __typename?: 'Mutation', bookScheduleItem: { __typename: 'ScheduleItem', id: string, userHasSpot: boolean, spacesLeft: number, hasSpacesLeft: boolean } | { __typename: 'ScheduleItemIsFull' } | { __typename: 'ScheduleItemNotBookable' } | { __typename: 'UserIsAlreadyBooked' } | { __typename: 'UserNeedsConferenceTicket' } };

export type CancelBookingScheduleItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelBookingScheduleItemMutation = { __typename?: 'Mutation', cancelBookingScheduleItem: { __typename: 'ScheduleItem', id: string, userHasSpot: boolean, hasSpacesLeft: boolean, spacesLeft: number } | { __typename: 'ScheduleItemNotBookable' } | { __typename: 'UserIsNotBooked' } };

export type TalkQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type TalkQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, talk?: { __typename?: 'ScheduleItem', id: string, title: string, type: string, image?: string | null, highlightColor?: string | null, description: string, hasLimitedCapacity: boolean, spacesLeft: number, hasSpacesLeft: boolean, slidoUrl: string, youtubeVideoId?: string | null, start: any, end: any, rooms: Array<{ __typename?: 'Room', id: string, name: string }>, language: { __typename?: 'Language', code: string }, submission?: { __typename?: 'Submission', id: string, abstract?: string | null, elevatorPitch?: string | null, duration?: { __typename?: 'Duration', id: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, topic?: { __typename?: 'Topic', name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', name: string, id: string }> | null } | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, participant?: { __typename?: 'Participant', id: string, photo: string, fullname: string, bio: string, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string, website: string } | null }> } | null } };

export type StarScheduleItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StarScheduleItemMutation = { __typename?: 'Mutation', starScheduleItem?: any | null };

export type UnstarScheduleItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnstarScheduleItemMutation = { __typename?: 'Mutation', unstarScheduleItem?: any | null };

export type SignupMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', register: { __typename: 'EmailAlreadyUsed', message: string } | { __typename: 'RegisterSuccess', user: { __typename?: 'User', id: string, email: string, fullname: string, name: string } } | { __typename: 'RegisterValidationError', errors: { __typename?: 'RegisterErrors', email?: Array<{ __typename?: 'FieldError', message: string, type: string }> | null, password?: Array<{ __typename?: 'FieldError', message: string, type: string }> | null, fullname?: Array<{ __typename?: 'FieldError', message: string, type: string }> | null } } };

export type SubmissionQueryVariables = Exact<{
  id: Scalars['ID'];
  language: Scalars['String'];
}>;


export type SubmissionQuery = { __typename?: 'Query', submission?: { __typename?: 'Submission', id: string, title: string, abstract?: string | null, elevatorPitch?: string | null, notes?: string | null, canEdit: boolean, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, duration?: { __typename?: 'Duration', id: string, name: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, languages?: Array<{ __typename?: 'Language', id: string, name: string, code: string }> | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null } | null };

export type CreateOrderMutationVariables = Exact<{
  conference: Scalars['String'];
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'CreateOrderResult', paymentUrl: string } | { __typename?: 'Error', message: string } };

export type GetVoucherQueryVariables = Exact<{
  conference: Scalars['String'];
  code: Scalars['String'];
}>;


export type GetVoucherQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, voucher?: { __typename?: 'Voucher', id: string, code: string, value: string, redeemed: number, maxUsages: number, priceMode: string, items: Array<string>, allItems: boolean, variationId?: string | null, validUntil?: any | null } | null } };

export type ConferenceProductsFragment = { __typename?: 'Conference', id: string, start: any, end: any, pretixEventUrl: string, timeZone: string, tickets: Array<{ __typename?: 'TicketItem', id: string, language?: string | null, name: string, description?: string | null, defaultPrice?: string | null, availableUntil?: string | null, quantityLeft?: number | null, soldOut?: boolean | null, type?: TicketType | null, category?: string | null, categoryInternalName?: string | null, taxRate?: number | null, admission: boolean, variations?: Array<{ __typename?: 'ProductVariation', id: string, defaultPrice: string, value: string, soldOut?: boolean | null, active: boolean, description: string }> | null, questions?: Array<{ __typename?: 'Question', id: string, name: string, required?: boolean | null, hidden: boolean, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null }> | null }>, hotelRooms: Array<{ __typename?: 'HotelRoom', id: string, name: string, description: string, price: string, isSoldOut: boolean, capacityLeft: number, checkInDates: Array<string>, checkOutDates: Array<string>, availableBedLayouts: Array<{ __typename?: 'BedLayout', id: string, name: string }> }> };

export type SubmissionAccordionFragment = { __typename?: 'Submission', id: string, title: string, elevatorPitch?: string | null, type?: { __typename?: 'SubmissionType', name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', name: string, id: string }> | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, duration?: { __typename?: 'Duration', id: string, name: string, duration: number } | null, languages?: Array<{ __typename?: 'Language', id: string, name: string, code: string }> | null, myVote?: { __typename?: 'VoteType', id: string, value: number } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', code: string, name: string }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, fullName: string, email: string, gender: string, dateBirth?: any | null, country: string, openToRecruiting: boolean, openToNewsletter: boolean, canEditSchedule: boolean, isPythonItaliaMember: boolean } };

export type AllPagesQueryVariables = Exact<{
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type AllPagesQuery = { __typename?: 'Query', cmsPages: Array<{ __typename?: 'GenericPage', id: string, slug: string }> };

export type PageQueryVariables = Exact<{
  code: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type PageQuery = { __typename?: 'Query', cmsPage?: { __typename?: 'GenericPage', id: string, title: string, searchDescription: string, body: Array<{ __typename?: 'CMSMap', id: string, latitude: any, longitude: any, link: string, image: string } | { __typename?: 'CheckoutSection', id: string, visibleCategories: Array<CheckoutCategory> } | { __typename?: 'HomeIntroSection', id: string, pretitle: string, title: string } | { __typename?: 'InformationSection', id: string, title: string, body: string, backgroundColor: string, illustration: string, countdownToDatetime?: any | null, countdownToDeadline?: string | null, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'KeynotersSection', id: string, title: string, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'LiveStreamingSection' } | { __typename?: 'NewsGridSection', id: string } | { __typename?: 'SchedulePreviewSection', id: string, title: string, primaryCta?: { __typename?: 'CTA', label: string, link: string } | null, secondaryCta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'SliderCardsSection', id: string, title: string, spacing: Spacing, snakeBackground: boolean, cards: Array<{ __typename?: 'PriceCard', title: string, body: string, price: string, priceTier: string, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'SimpleTextCard', title: string, body: string, cta?: { __typename?: 'CTA', label: string, link: string } | null }> } | { __typename?: 'SocialsSection', id: string, label: string, hashtag: string } | { __typename?: 'SpecialGuestSection', id: string, title: string, guestName: string, guestJobTitle: string, guestPhoto: string, eventDate: any, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'SponsorsSection', id: string, title: string, body: string, layout: SponsorsSectionLayout, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'TextSection', id: string, body: string, bodyTextSize: BodyTextSize, illustration: string, subtitle: string, title: string, isMainTitle: boolean, accordions: Array<{ __typename?: 'Accordion', title: string, body: string, isOpen: boolean }>, cta?: { __typename?: 'CTA', label: string, link: string } | null }> } | { __typename?: 'SiteNotFoundError' } | null };

export type TicketIdToUserHashidQueryVariables = Exact<{
  ticketId: Scalars['ID'];
  conference: Scalars['String'];
}>;


export type TicketIdToUserHashidQuery = { __typename?: 'Query', ticketIdToUserHashid?: string | null };

export type IsCfpOpenQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type IsCfpOpenQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, isCFPOpen: boolean, cfpDeadline?: { __typename?: 'Deadline', id: string, end: any } | null } };

export type MeSubmissionsQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type MeSubmissionsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, submissions: Array<{ __typename?: 'Submission', id: string, title: string }> } };

export type TalkSocialCardQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
}>;


export type TalkSocialCardQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, talk?: { __typename?: 'ScheduleItem', id: string, title: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> } | null } };

export type AllTalksQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type AllTalksQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, talks: Array<{ __typename?: 'ScheduleItem', id: string, slug: string }> } };

export type WorkshopBookingStateQueryVariables = Exact<{
  slug: Scalars['String'];
  code: Scalars['String'];
}>;


export type WorkshopBookingStateQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, talk?: { __typename?: 'ScheduleItem', id: string, hasLimitedCapacity: boolean, spacesLeft: number, hasSpacesLeft: boolean, userHasSpot: boolean } | null } };

export type UpdateGrantMutationVariables = Exact<{
  input: UpdateGrantInput;
}>;


export type UpdateGrantMutation = { __typename?: 'Mutation', mutationOp: { __typename: 'Grant', id: string, name: string, fullName: string, gender: string, grantType: GrantType, occupation: Occupation, ageGroup?: AgeGroup | null, pythonUsage: string, beenToOtherEvents: string, interestedInVolunteering: InterestedInVolunteering, needsFundsForTravel: boolean, notes: string, travellingFrom: string } | { __typename: 'GrantErrors', nonFieldErrors: Array<string>, validationConference: Array<string>, validationName: Array<string>, validationFullName: Array<string>, validationGender: Array<string>, validationGrantType: Array<string>, validationOccupation: Array<string>, validationAgeGroup: Array<string>, validationPythonUsage: Array<string>, validationBeenToOtherEvents: Array<string>, validationInterestedInVolunteering: Array<string>, validationNeedsFundsForTravel: Array<string>, validationWhy: Array<string>, validationNotes: Array<string>, validationTravellingFrom: Array<string> } };

export type GrantQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type GrantQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, grant?: { __typename?: 'Grant', id: string, status: Status, applicantReplyDeadline?: any | null, applicantMessage?: string | null } | null } };

export type SendGrantReplyMutationVariables = Exact<{
  input: SendGrantReplyInput;
}>;


export type SendGrantReplyMutation = { __typename?: 'Mutation', sendGrantReply: { __typename?: 'Grant', id: string, status: Status } | { __typename?: 'SendGrantReplyError', message: string } };

export type KeynoteSocialCardQueryVariables = Exact<{
  conference: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynoteSocialCardQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, keynote?: { __typename?: 'Keynote', id: string, title: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> } | null } };

export type AllKeynotesQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type AllKeynotesQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, keynotes: Array<{ __typename?: 'Keynote', id: string, slug: string }> } };

export type KeynoteQueryVariables = Exact<{
  conference: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynoteQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, keynote?: { __typename?: 'Keynote', id: string, title: string, description: string, slug: string, start?: any | null, end?: any | null, youtubeVideoId?: string | null, rooms: Array<{ __typename?: 'Room', id: string, name: string }>, topic?: { __typename?: 'Topic', id: string, name: string } | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, participant?: { __typename?: 'Participant', id: string, photo: string, bio: string, fullname: string, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string, website: string } | null }> } | null } };

export type KeynotesPageQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type KeynotesPageQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, title?: string | null, subtitle?: string | null, description?: string | null, keynotes: Array<{ __typename?: 'Keynote', id: string, title: string, slug: string, start?: any | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, participant?: { __typename?: 'Participant', id: string, photo: string, fullname: string, twitterHandle: string, instagramHandle: string, linkedinUrl: string, facebookUrl: string, mastodonHandle: string } | null }> }> } };

export type AllNewsArticlesQueryVariables = Exact<{
  code: Scalars['String'];
  language: Scalars['String'];
}>;


export type AllNewsArticlesQuery = { __typename?: 'Query', newsArticles: Array<{ __typename?: 'NewsArticle', id: string, slug: string }> };

export type NewsArticleSocialCardQueryVariables = Exact<{
  code: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type NewsArticleSocialCardQuery = { __typename?: 'Query', newsArticle?: { __typename?: 'NewsArticle', id: string, title: string, authorFullname: string } | null };

export type NewsArticleQueryVariables = Exact<{
  code: Scalars['String'];
  slug: Scalars['String'];
  language: Scalars['String'];
}>;


export type NewsArticleQuery = { __typename?: 'Query', newsArticle?: { __typename?: 'NewsArticle', id: string, title: string, excerpt: string, body: string, publishedAt: any, authorFullname: string } | null, blogPost?: { __typename?: 'Post', id: string, title: string, content: string, excerpt: string, published: any, author: { __typename?: 'BlogPostAuthor', fullName: string } } | null };

export type OrderQueryVariables = Exact<{
  conferenceCode: Scalars['String'];
  code: Scalars['String'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'PretixOrder', code: string, status: PretixOrderStatus, url: string } | null };

export type AddScheduleSlotMutationVariables = Exact<{
  code: Scalars['ID'];
  day: Scalars['Date'];
  duration: Scalars['Int'];
  language: Scalars['String'];
}>;


export type AddScheduleSlotMutation = { __typename?: 'Mutation', addScheduleSlot: { __typename?: 'AddScheduleSlotError' } | { __typename?: 'Day', day: any, slots: Array<{ __typename?: 'ScheduleSlot', id: string, hour: any, endHour: any, duration: number, type: ScheduleSlotType, items: Array<{ __typename?: 'ScheduleItem', id: string, title: string, slug: string, type: string, duration?: number | null, hasLimitedCapacity: boolean, userHasSpot: boolean, hasSpacesLeft: boolean, spacesLeft: number, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, language: { __typename?: 'Language', id: string, name: string, code: string }, submission?: { __typename?: 'Submission', id: string, title: string, duration?: { __typename?: 'Duration', id: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, speaker?: { __typename?: 'SubmissionSpeaker', id: string, fullName: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null } | null, keynote?: { __typename?: 'Keynote', id: string, title: string, slug: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> } | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string, participant?: { __typename?: 'Participant', id: string, photo: string } | null }>, rooms: Array<{ __typename?: 'Room', id: string, name: string, type: string }> }> }> } };

type Blocks_CmsMap_Fragment = { __typename?: 'CMSMap', id: string, latitude: any, longitude: any, link: string, image: string };

type Blocks_CheckoutSection_Fragment = { __typename?: 'CheckoutSection', id: string, visibleCategories: Array<CheckoutCategory> };

type Blocks_HomeIntroSection_Fragment = { __typename?: 'HomeIntroSection', id: string, pretitle: string, title: string };

type Blocks_InformationSection_Fragment = { __typename?: 'InformationSection', id: string, title: string, body: string, backgroundColor: string, illustration: string, countdownToDatetime?: any | null, countdownToDeadline?: string | null, cta?: { __typename?: 'CTA', label: string, link: string } | null };

type Blocks_KeynotersSection_Fragment = { __typename?: 'KeynotersSection', id: string, title: string, cta?: { __typename?: 'CTA', label: string, link: string } | null };

type Blocks_LiveStreamingSection_Fragment = { __typename?: 'LiveStreamingSection' };

type Blocks_NewsGridSection_Fragment = { __typename?: 'NewsGridSection', id: string };

type Blocks_SchedulePreviewSection_Fragment = { __typename?: 'SchedulePreviewSection', id: string, title: string, primaryCta?: { __typename?: 'CTA', label: string, link: string } | null, secondaryCta?: { __typename?: 'CTA', label: string, link: string } | null };

type Blocks_SliderCardsSection_Fragment = { __typename?: 'SliderCardsSection', id: string, title: string, spacing: Spacing, snakeBackground: boolean, cards: Array<{ __typename?: 'PriceCard', title: string, body: string, price: string, priceTier: string, cta?: { __typename?: 'CTA', label: string, link: string } | null } | { __typename?: 'SimpleTextCard', title: string, body: string, cta?: { __typename?: 'CTA', label: string, link: string } | null }> };

type Blocks_SocialsSection_Fragment = { __typename?: 'SocialsSection', id: string, label: string, hashtag: string };

type Blocks_SpecialGuestSection_Fragment = { __typename?: 'SpecialGuestSection', id: string, title: string, guestName: string, guestJobTitle: string, guestPhoto: string, eventDate: any, cta?: { __typename?: 'CTA', label: string, link: string } | null };

type Blocks_SponsorsSection_Fragment = { __typename?: 'SponsorsSection', id: string, title: string, body: string, layout: SponsorsSectionLayout, cta?: { __typename?: 'CTA', label: string, link: string } | null };

type Blocks_TextSection_Fragment = { __typename?: 'TextSection', id: string, body: string, bodyTextSize: BodyTextSize, illustration: string, subtitle: string, title: string, isMainTitle: boolean, accordions: Array<{ __typename?: 'Accordion', title: string, body: string, isOpen: boolean }>, cta?: { __typename?: 'CTA', label: string, link: string } | null };

export type BlocksFragment = Blocks_CmsMap_Fragment | Blocks_CheckoutSection_Fragment | Blocks_HomeIntroSection_Fragment | Blocks_InformationSection_Fragment | Blocks_KeynotersSection_Fragment | Blocks_LiveStreamingSection_Fragment | Blocks_NewsGridSection_Fragment | Blocks_SchedulePreviewSection_Fragment | Blocks_SliderCardsSection_Fragment | Blocks_SocialsSection_Fragment | Blocks_SpecialGuestSection_Fragment | Blocks_SponsorsSection_Fragment | Blocks_TextSection_Fragment;

export type CtaInfoFragment = { __typename?: 'CTA', label: string, link: string };

export type KeynoteFragmentFragment = { __typename?: 'Keynote', id: string, title: string, slug: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> };

export type ScheduleSlotFragmentFragment = { __typename?: 'ScheduleSlot', id: string, hour: any, endHour: any, duration: number, type: ScheduleSlotType, items: Array<{ __typename?: 'ScheduleItem', id: string, title: string, slug: string, type: string, duration?: number | null, hasLimitedCapacity: boolean, userHasSpot: boolean, hasSpacesLeft: boolean, spacesLeft: number, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, language: { __typename?: 'Language', id: string, name: string, code: string }, submission?: { __typename?: 'Submission', id: string, title: string, duration?: { __typename?: 'Duration', id: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, speaker?: { __typename?: 'SubmissionSpeaker', id: string, fullName: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null } | null, keynote?: { __typename?: 'Keynote', id: string, title: string, slug: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> } | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string, participant?: { __typename?: 'Participant', id: string, photo: string } | null }>, rooms: Array<{ __typename?: 'Room', id: string, name: string, type: string }> }> };

export type SubmissionFragmentFragment = { __typename?: 'Submission', id: string, title: string, duration?: { __typename?: 'Duration', id: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, speaker?: { __typename?: 'SubmissionSpeaker', id: string, fullName: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null };

export type GetScheduleInvitationQueryVariables = Exact<{
  submissionId: Scalars['ID'];
  language: Scalars['String'];
}>;


export type GetScheduleInvitationQuery = { __typename?: 'Query', scheduleInvitation?: { __typename?: 'ScheduleInvitation', id: string, option: ScheduleInvitationOption, notes: string, title: string, submission: { __typename?: 'Submission', id: string, title: string }, dates: Array<{ __typename?: 'ScheduleInvitationDate', id: string, start: any, end: any }> } | null };

export type UpdateScheduleInvitationMutationVariables = Exact<{
  input: UpdateScheduleInvitationInput;
}>;


export type UpdateScheduleInvitationMutation = { __typename?: 'Mutation', updateScheduleInvitation: { __typename: 'ScheduleInvitation', id: string, option: ScheduleInvitationOption, notes: string } | { __typename: 'ScheduleInvitationNotFound', message: string } };

export type ScheduleDaysQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ScheduleDaysQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, days: Array<{ __typename?: 'Day', day: any }> } };

export type ScheduleQueryVariables = Exact<{
  code: Scalars['String'];
  fetchSubmissions: Scalars['Boolean'];
  language: Scalars['String'];
}>;


export type ScheduleQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, timezone: string, days: Array<{ __typename?: 'Day', day: any, rooms: Array<{ __typename?: 'DayRoom', id: string, name: string, type: string }>, slots: Array<{ __typename?: 'ScheduleSlot', id: string, hour: any, endHour: any, duration: number, type: ScheduleSlotType, items: Array<{ __typename?: 'ScheduleItem', id: string, title: string, slug: string, type: string, duration?: number | null, hasLimitedCapacity: boolean, userHasSpot: boolean, hasSpacesLeft: boolean, spacesLeft: number, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, language: { __typename?: 'Language', id: string, name: string, code: string }, submission?: { __typename?: 'Submission', id: string, title: string, duration?: { __typename?: 'Duration', id: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, speaker?: { __typename?: 'SubmissionSpeaker', id: string, fullName: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null } | null, keynote?: { __typename?: 'Keynote', id: string, title: string, slug: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> } | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string, participant?: { __typename?: 'Participant', id: string, photo: string } | null }>, rooms: Array<{ __typename?: 'Room', id: string, name: string, type: string }> }> }> }>, submissions?: Array<{ __typename?: 'Submission', id: string, title: string, duration?: { __typename?: 'Duration', id: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, speaker?: { __typename?: 'SubmissionSpeaker', id: string, fullName: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null }> | null, keynotes?: Array<{ __typename?: 'Keynote', id: string, title: string, slug: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> }>, audienceLevels: Array<{ __typename?: 'AudienceLevel', id: string, name: string }>, durations: Array<{ __typename?: 'Duration', id: string, duration: number, allowedSubmissionTypes: Array<{ __typename?: 'SubmissionType', name: string }> }> } };

export type UpdateOrCreateSlotItemMutationVariables = Exact<{
  input: UpdateOrCreateSlotItemInput;
  language: Scalars['String'];
}>;


export type UpdateOrCreateSlotItemMutation = { __typename?: 'Mutation', updateOrCreateSlotItem: { __typename?: 'UpdateOrCreateSlotItemError' } | { __typename?: 'UpdateOrCreateSlotItemResult', updatedSlots: Array<{ __typename?: 'ScheduleSlot', id: string, hour: any, endHour: any, duration: number, type: ScheduleSlotType, items: Array<{ __typename?: 'ScheduleItem', id: string, title: string, slug: string, type: string, duration?: number | null, hasLimitedCapacity: boolean, userHasSpot: boolean, hasSpacesLeft: boolean, spacesLeft: number, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, language: { __typename?: 'Language', id: string, name: string, code: string }, submission?: { __typename?: 'Submission', id: string, title: string, duration?: { __typename?: 'Duration', id: string, duration: number } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, speaker?: { __typename?: 'SubmissionSpeaker', id: string, fullName: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null } | null, keynote?: { __typename?: 'Keynote', id: string, title: string, slug: string, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string }> } | null, speakers: Array<{ __typename?: 'ScheduleItemUser', id: string, fullName: string, participant?: { __typename?: 'Participant', id: string, photo: string } | null }>, rooms: Array<{ __typename?: 'Room', id: string, name: string, type: string }> }> }> } };

export type UserStarredScheduleItemsQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type UserStarredScheduleItemsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, starredScheduleItems: Array<string> } };

export type SocialCardQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SocialCardQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, start: any, end: any, name: string } };

export type GetSubmissionQueryVariables = Exact<{
  id: Scalars['ID'];
  language: Scalars['String'];
}>;


export type GetSubmissionQuery = { __typename?: 'Query', submission?: { __typename?: 'Submission', id: string, title: string, abstract?: string | null, elevatorPitch?: string | null, shortSocialSummary?: string | null, notes?: string | null, canEdit: boolean, speakerLevel?: string | null, previousTalkVideo?: string | null, multilingualTitle?: { __typename?: 'MultiLingualString', it: string, en: string } | null, multilingualAbstract?: { __typename?: 'MultiLingualString', it: string, en: string } | null, multilingualElevatorPitch?: { __typename?: 'MultiLingualString', it: string, en: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, topic?: { __typename?: 'Topic', id: string, name: string } | null, duration?: { __typename?: 'Duration', id: string, name: string } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, languages?: Array<{ __typename?: 'Language', id: string, code: string, name: string }> | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null } | null };

export type UpdateSubmissionMutationVariables = Exact<{
  input: UpdateSubmissionInput;
  language: Scalars['String'];
}>;


export type UpdateSubmissionMutation = { __typename?: 'Mutation', mutationOp: { __typename: 'SendSubmissionErrors', nonFieldErrors: Array<string>, validationTitle: Array<string>, validationAbstract: Array<string>, validationTopic: Array<string>, validationLanguages: Array<string>, validationType: Array<string>, validationDuration: Array<string>, validationElevatorPitch: Array<string>, validationNotes: Array<string>, validationAudienceLevel: Array<string>, validationTags: Array<string>, validationPreviousTalkVideo: Array<string>, validationSpeakerLevel: Array<string>, validationShortSocialSummary: Array<string>, validationSpeakerBio: Array<string>, validationSpeakerWebsite: Array<string>, validationSpeakerPhoto: Array<string>, validationSpeakerTwitterHandle: Array<string>, validationSpeakerInstagramHandle: Array<string>, validationSpeakerLinkedinUrl: Array<string>, validationSpeakerFacebookUrl: Array<string>, validationSpeakerMastodonHandle: Array<string> } | { __typename: 'Submission', id: string, title: string, abstract?: string | null, elevatorPitch?: string | null, shortSocialSummary?: string | null, notes?: string | null, speakerLevel?: string | null, previousTalkVideo?: string | null, multilingualTitle?: { __typename?: 'MultiLingualString', it: string, en: string } | null, multilingualAbstract?: { __typename?: 'MultiLingualString', it: string, en: string } | null, multilingualElevatorPitch?: { __typename?: 'MultiLingualString', it: string, en: string } | null, type?: { __typename?: 'SubmissionType', id: string, name: string } | null, topic?: { __typename?: 'Topic', id: string, name: string } | null, duration?: { __typename?: 'Duration', id: string, name: string } | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, languages?: Array<{ __typename?: 'Language', id: string, code: string, name: string }> | null, tags?: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> | null } };

export type IsVotingClosedQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type IsVotingClosedQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, isVotingClosed: boolean } };

export type TicketsQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
}>;


export type TicketsQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, start: any, end: any, pretixEventUrl: string, timeZone: string, tickets: Array<{ __typename?: 'TicketItem', id: string, language?: string | null, name: string, description?: string | null, defaultPrice?: string | null, availableUntil?: string | null, quantityLeft?: number | null, soldOut?: boolean | null, type?: TicketType | null, category?: string | null, categoryInternalName?: string | null, taxRate?: number | null, admission: boolean, variations?: Array<{ __typename?: 'ProductVariation', id: string, defaultPrice: string, value: string, soldOut?: boolean | null, active: boolean, description: string }> | null, questions?: Array<{ __typename?: 'Question', id: string, name: string, required?: boolean | null, hidden: boolean, options?: Array<{ __typename?: 'Option', id: string, name: string }> | null }> | null }>, hotelRooms: Array<{ __typename?: 'HotelRoom', id: string, name: string, description: string, price: string, isSoldOut: boolean, capacityLeft: number, checkInDates: Array<string>, checkOutDates: Array<string>, availableBedLayouts: Array<{ __typename?: 'BedLayout', id: string, name: string }> }> } };

export type SendVoteMutationVariables = Exact<{
  input: SendVoteInput;
}>;


export type SendVoteMutation = { __typename?: 'Mutation', sendVote: { __typename: 'SendVoteErrors', nonFieldErrors: Array<string>, validationValue: Array<string>, validationSubmission: Array<string> } | { __typename: 'VoteType', id: string, value: number } };

export type VotingMetadataQueryVariables = Exact<{
  conference: Scalars['String'];
}>;


export type VotingMetadataQuery = { __typename?: 'Query', conference: { __typename?: 'Conference', id: string, isVotingOpen: boolean, votingDeadline?: { __typename?: 'Deadline', id: string, end: any } | null, topics: Array<{ __typename?: 'Topic', id: string, name: string }>, languages: Array<{ __typename?: 'Language', id: string, name: string, code: string }>, audienceLevels: Array<{ __typename?: 'AudienceLevel', id: string, name: string }>, submissionTypes: Array<{ __typename?: 'SubmissionType', id: string, name: string }> }, votingTags: Array<{ __typename?: 'SubmissionTag', id: string, name: string }> };

export type VotingSubmissionsQueryVariables = Exact<{
  conference: Scalars['String'];
  language: Scalars['String'];
  languages?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  voted?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  audienceLevels?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type VotingSubmissionsQuery = { __typename?: 'Query', submissions?: { __typename?: 'SubmissionPaginated', pageInfo: { __typename?: 'PageInfo', totalPages: number, totalItems: number }, items: Array<{ __typename?: 'Submission', id: string, title: string, elevatorPitch?: string | null, type?: { __typename?: 'SubmissionType', name: string } | null, tags?: Array<{ __typename?: 'SubmissionTag', name: string, id: string }> | null, audienceLevel?: { __typename?: 'AudienceLevel', id: string, name: string } | null, duration?: { __typename?: 'Duration', id: string, name: string, duration: number } | null, languages?: Array<{ __typename?: 'Language', id: string, name: string, code: string }> | null, myVote?: { __typename?: 'VoteType', id: string, value: number } | null }> } | null };

export const ConferenceProductsFragmentDoc = gql`
    fragment ConferenceProducts on Conference {
  id
  start
  end
  timeZone: timezone
  pretixEventUrl
  tickets(language: $language) {
    id
    language
    name
    description
    defaultPrice
    availableUntil
    quantityLeft
    soldOut
    type
    category
    categoryInternalName
    taxRate
    admission
    variations {
      id
      defaultPrice
      value
      soldOut
      active
      description
    }
    questions {
      id
      name
      required
      hidden
      options {
        id
        name
      }
    }
  }
  hotelRooms {
    id
    name(language: $language)
    description(language: $language)
    price
    isSoldOut
    capacityLeft
    availableBedLayouts {
      id
      name(language: $language)
    }
    checkInDates
    checkOutDates
  }
}
    `;
export const SubmissionAccordionFragmentDoc = gql`
    fragment submissionAccordion on Submission {
  id
  title(language: $language)
  elevatorPitch(language: $language)
  type {
    name
  }
  tags {
    name
    id
  }
  audienceLevel {
    id
    name
  }
  duration {
    id
    name
    duration
  }
  languages {
    id
    name
    code
  }
  myVote {
    id
    value
  }
}
    `;
export const CtaInfoFragmentDoc = gql`
    fragment CTAInfo on CTA {
  label
  link
}
    `;
export const BlocksFragmentDoc = gql`
    fragment Blocks on Block {
  ... on TextSection {
    id
    body
    bodyTextSize
    illustration
    subtitle
    title
    isMainTitle
    accordions {
      title
      body
      isOpen
    }
    cta {
      ...CTAInfo
    }
  }
  ... on CMSMap {
    id
    latitude
    longitude
    link
    image
  }
  ... on SliderCardsSection {
    id
    title
    spacing
    snakeBackground
    cards {
      ... on SimpleTextCard {
        title
        body
        cta {
          ...CTAInfo
        }
      }
      ... on PriceCard {
        title
        body
        price
        priceTier
        cta {
          ...CTAInfo
        }
      }
    }
  }
  ... on SponsorsSection {
    id
    title
    body
    cta {
      ...CTAInfo
    }
    layout
  }
  ... on HomeIntroSection {
    id
    pretitle
    title
  }
  ... on KeynotersSection {
    id
    title
    cta {
      ...CTAInfo
    }
  }
  ... on SchedulePreviewSection {
    id
    title
    primaryCta {
      ...CTAInfo
    }
    secondaryCta {
      ...CTAInfo
    }
  }
  ... on SocialsSection {
    id
    label
    hashtag
  }
  ... on SpecialGuestSection {
    id
    title
    guestName
    guestJobTitle
    guestPhoto
    eventDate
    cta {
      ...CTAInfo
    }
  }
  ... on InformationSection {
    id
    title
    body
    backgroundColor
    illustration
    countdownToDatetime
    countdownToDeadline
    cta {
      ...CTAInfo
    }
  }
  ... on NewsGridSection {
    id
  }
  ... on CheckoutSection {
    id
    visibleCategories
  }
}
    ${CtaInfoFragmentDoc}`;
export const SubmissionFragmentFragmentDoc = gql`
    fragment SubmissionFragment on Submission {
  id
  title(language: $language)
  duration {
    id
    duration
  }
  audienceLevel {
    id
    name
  }
  speaker {
    id
    fullName
  }
  type {
    id
    name
  }
  tags {
    id
    name
  }
}
    `;
export const KeynoteFragmentFragmentDoc = gql`
    fragment KeynoteFragment on Keynote {
  id
  title(language: "en")
  slug(language: "en")
  speakers {
    id
    fullName
  }
}
    `;
export const ScheduleSlotFragmentFragmentDoc = gql`
    fragment ScheduleSlotFragment on ScheduleSlot {
  id
  hour
  endHour
  duration
  type
  items {
    id
    title
    slug
    type
    duration
    hasLimitedCapacity
    userHasSpot
    hasSpacesLeft
    spacesLeft
    audienceLevel {
      id
      name
    }
    language {
      id
      name
      code
    }
    submission {
      ...SubmissionFragment
    }
    keynote {
      ...KeynoteFragment
    }
    speakers {
      id
      fullName
      participant {
        id
        photo
      }
    }
    rooms {
      id
      name
      type
    }
  }
}
    ${SubmissionFragmentFragmentDoc}
${KeynoteFragmentFragmentDoc}`;
export const CheckoutSectionDocument = gql`
    query CheckoutSection($conference: String!, $language: String!) {
  conference(code: $conference) {
    ...ConferenceProducts
  }
}
    ${ConferenceProductsFragmentDoc}`;

/**
 * __useCheckoutSectionQuery__
 *
 * To run a query within a React component, call `useCheckoutSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSectionQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCheckoutSectionQuery(baseOptions: Apollo.QueryHookOptions<CheckoutSectionQuery, CheckoutSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutSectionQuery, CheckoutSectionQueryVariables>(CheckoutSectionDocument, options);
      }
export function useCheckoutSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutSectionQuery, CheckoutSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutSectionQuery, CheckoutSectionQueryVariables>(CheckoutSectionDocument, options);
        }
export type CheckoutSectionQueryHookResult = ReturnType<typeof useCheckoutSectionQuery>;
export type CheckoutSectionLazyQueryHookResult = ReturnType<typeof useCheckoutSectionLazyQuery>;
export type CheckoutSectionQueryResult = Apollo.QueryResult<CheckoutSectionQuery, CheckoutSectionQueryVariables>;
export const InformationSectionDocument = gql`
    query InformationSection($code: String!) {
  conference(code: $code) {
    id
    cfp: deadline(type: "cfp") {
      id
      start
      end
    }
    voting: deadline(type: "voting") {
      id
      start
      end
    }
    grants: deadline(type: "grants") {
      id
      start
      end
    }
  }
}
    `;

/**
 * __useInformationSectionQuery__
 *
 * To run a query within a React component, call `useInformationSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInformationSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInformationSectionQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useInformationSectionQuery(baseOptions: Apollo.QueryHookOptions<InformationSectionQuery, InformationSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InformationSectionQuery, InformationSectionQueryVariables>(InformationSectionDocument, options);
      }
export function useInformationSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InformationSectionQuery, InformationSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InformationSectionQuery, InformationSectionQueryVariables>(InformationSectionDocument, options);
        }
export type InformationSectionQueryHookResult = ReturnType<typeof useInformationSectionQuery>;
export type InformationSectionLazyQueryHookResult = ReturnType<typeof useInformationSectionLazyQuery>;
export type InformationSectionQueryResult = Apollo.QueryResult<InformationSectionQuery, InformationSectionQueryVariables>;
export const KeynotesSectionDocument = gql`
    query KeynotesSection($code: String!, $language: String!) {
  conference(code: $code) {
    id
    keynotes {
      id
      title(language: $language)
      slug(language: $language)
      start
      speakers {
        id
        fullName
        participant {
          id
          photo
          twitterHandle
          instagramHandle
          linkedinUrl
          facebookUrl
          mastodonHandle
        }
      }
    }
  }
}
    `;

/**
 * __useKeynotesSectionQuery__
 *
 * To run a query within a React component, call `useKeynotesSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynotesSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynotesSectionQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynotesSectionQuery(baseOptions: Apollo.QueryHookOptions<KeynotesSectionQuery, KeynotesSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynotesSectionQuery, KeynotesSectionQueryVariables>(KeynotesSectionDocument, options);
      }
export function useKeynotesSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynotesSectionQuery, KeynotesSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynotesSectionQuery, KeynotesSectionQueryVariables>(KeynotesSectionDocument, options);
        }
export type KeynotesSectionQueryHookResult = ReturnType<typeof useKeynotesSectionQuery>;
export type KeynotesSectionLazyQueryHookResult = ReturnType<typeof useKeynotesSectionLazyQuery>;
export type KeynotesSectionQueryResult = Apollo.QueryResult<KeynotesSectionQuery, KeynotesSectionQueryVariables>;
export const LiveStreamingSectionDocument = gql`
    query LiveStreamingSection($code: String!) {
  conference(code: $code) {
    id
    timezone
    currentDay {
      day
      runningEvents {
        id
        slidoUrl
        duration
        title
        type
        rooms {
          id
          name
        }
      }
      rooms {
        id
        name
        type
        streamingUrl
        slidoUrl
      }
    }
  }
}
    `;

/**
 * __useLiveStreamingSectionQuery__
 *
 * To run a query within a React component, call `useLiveStreamingSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveStreamingSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveStreamingSectionQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useLiveStreamingSectionQuery(baseOptions: Apollo.QueryHookOptions<LiveStreamingSectionQuery, LiveStreamingSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveStreamingSectionQuery, LiveStreamingSectionQueryVariables>(LiveStreamingSectionDocument, options);
      }
export function useLiveStreamingSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveStreamingSectionQuery, LiveStreamingSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveStreamingSectionQuery, LiveStreamingSectionQueryVariables>(LiveStreamingSectionDocument, options);
        }
export type LiveStreamingSectionQueryHookResult = ReturnType<typeof useLiveStreamingSectionQuery>;
export type LiveStreamingSectionLazyQueryHookResult = ReturnType<typeof useLiveStreamingSectionLazyQuery>;
export type LiveStreamingSectionQueryResult = Apollo.QueryResult<LiveStreamingSectionQuery, LiveStreamingSectionQueryVariables>;
export const NewsGridSectionDocument = gql`
    query NewsGridSection($code: String!, $language: String!) {
  newsArticles(hostname: $code, language: $language) {
    id
    slug
    title
    publishedAt
  }
  blogPosts {
    id
    slug
    title(language: $language)
    excerpt(language: $language)
    author {
      fullName
    }
    published
  }
}
    `;

/**
 * __useNewsGridSectionQuery__
 *
 * To run a query within a React component, call `useNewsGridSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsGridSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsGridSectionQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useNewsGridSectionQuery(baseOptions: Apollo.QueryHookOptions<NewsGridSectionQuery, NewsGridSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsGridSectionQuery, NewsGridSectionQueryVariables>(NewsGridSectionDocument, options);
      }
export function useNewsGridSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsGridSectionQuery, NewsGridSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsGridSectionQuery, NewsGridSectionQueryVariables>(NewsGridSectionDocument, options);
        }
export type NewsGridSectionQueryHookResult = ReturnType<typeof useNewsGridSectionQuery>;
export type NewsGridSectionLazyQueryHookResult = ReturnType<typeof useNewsGridSectionLazyQuery>;
export type NewsGridSectionQueryResult = Apollo.QueryResult<NewsGridSectionQuery, NewsGridSectionQueryVariables>;
export const SchedulePreviewSectionDocument = gql`
    query SchedulePreviewSection($code: String!) {
  conference(code: $code) {
    id
    days {
      day
      randomEvents {
        id
        title
        slug
        start
        end
        submission {
          id
          audienceLevel {
            id
            name
          }
        }
        audienceLevel {
          id
          name
        }
        language {
          id
          name
        }
        speakers {
          id
          fullName
          participant {
            id
            photo
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSchedulePreviewSectionQuery__
 *
 * To run a query within a React component, call `useSchedulePreviewSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulePreviewSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulePreviewSectionQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSchedulePreviewSectionQuery(baseOptions: Apollo.QueryHookOptions<SchedulePreviewSectionQuery, SchedulePreviewSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulePreviewSectionQuery, SchedulePreviewSectionQueryVariables>(SchedulePreviewSectionDocument, options);
      }
export function useSchedulePreviewSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulePreviewSectionQuery, SchedulePreviewSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulePreviewSectionQuery, SchedulePreviewSectionQueryVariables>(SchedulePreviewSectionDocument, options);
        }
export type SchedulePreviewSectionQueryHookResult = ReturnType<typeof useSchedulePreviewSectionQuery>;
export type SchedulePreviewSectionLazyQueryHookResult = ReturnType<typeof useSchedulePreviewSectionLazyQuery>;
export type SchedulePreviewSectionQueryResult = Apollo.QueryResult<SchedulePreviewSectionQuery, SchedulePreviewSectionQueryVariables>;
export const SponsorsSectionDocument = gql`
    query SponsorsSection($code: String!) {
  conference(code: $code) {
    id
    sponsorsByLevel {
      name: level
      sponsors {
        id
        name
        url: link
        logo: image
      }
    }
  }
}
    `;

/**
 * __useSponsorsSectionQuery__
 *
 * To run a query within a React component, call `useSponsorsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorsSectionQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSponsorsSectionQuery(baseOptions: Apollo.QueryHookOptions<SponsorsSectionQuery, SponsorsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorsSectionQuery, SponsorsSectionQueryVariables>(SponsorsSectionDocument, options);
      }
export function useSponsorsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorsSectionQuery, SponsorsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorsSectionQuery, SponsorsSectionQueryVariables>(SponsorsSectionDocument, options);
        }
export type SponsorsSectionQueryHookResult = ReturnType<typeof useSponsorsSectionQuery>;
export type SponsorsSectionLazyQueryHookResult = ReturnType<typeof useSponsorsSectionLazyQuery>;
export type SponsorsSectionQueryResult = Apollo.QueryResult<SponsorsSectionQuery, SponsorsSectionQueryVariables>;
export const CfpFormDocument = gql`
    query CfpForm($conference: String!) {
  conference(code: $conference) {
    id
    durations {
      name
      id
      allowedSubmissionTypes {
        id
        name
      }
    }
    audienceLevels {
      id
      name
    }
    submissionTypes {
      id
      name
    }
    languages {
      code
      id
      name
    }
  }
}
    `;

/**
 * __useCfpFormQuery__
 *
 * To run a query within a React component, call `useCfpFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCfpFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCfpFormQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useCfpFormQuery(baseOptions: Apollo.QueryHookOptions<CfpFormQuery, CfpFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CfpFormQuery, CfpFormQueryVariables>(CfpFormDocument, options);
      }
export function useCfpFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CfpFormQuery, CfpFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CfpFormQuery, CfpFormQueryVariables>(CfpFormDocument, options);
        }
export type CfpFormQueryHookResult = ReturnType<typeof useCfpFormQuery>;
export type CfpFormLazyQueryHookResult = ReturnType<typeof useCfpFormLazyQuery>;
export type CfpFormQueryResult = Apollo.QueryResult<CfpFormQuery, CfpFormQueryVariables>;
export const ParticipantDataDocument = gql`
    query ParticipantData($conference: String!) {
  me {
    id
    participant(conference: $conference) {
      id
      photo
      bio
      website
      speakerLevel
      previousTalkVideo
      twitterHandle
      instagramHandle
      linkedinUrl
      facebookUrl
      mastodonHandle
    }
  }
}
    `;

/**
 * __useParticipantDataQuery__
 *
 * To run a query within a React component, call `useParticipantDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantDataQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useParticipantDataQuery(baseOptions: Apollo.QueryHookOptions<ParticipantDataQuery, ParticipantDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantDataQuery, ParticipantDataQueryVariables>(ParticipantDataDocument, options);
      }
export function useParticipantDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantDataQuery, ParticipantDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantDataQuery, ParticipantDataQueryVariables>(ParticipantDataDocument, options);
        }
export type ParticipantDataQueryHookResult = ReturnType<typeof useParticipantDataQuery>;
export type ParticipantDataLazyQueryHookResult = ReturnType<typeof useParticipantDataLazyQuery>;
export type ParticipantDataQueryResult = Apollo.QueryResult<ParticipantDataQuery, ParticipantDataQueryVariables>;
export const SendSubmissionDocument = gql`
    mutation SendSubmission($input: SendSubmissionInput!, $language: String!) {
  mutationOp: sendSubmission(input: $input) {
    __typename
    ... on Submission {
      id
      title(language: $language)
    }
    ... on SendSubmissionErrors {
      validationTitle: title
      validationAbstract: abstract
      validationLanguages: languages
      validationType: type
      validationDuration: duration
      validationElevatorPitch: elevatorPitch
      validationNotes: notes
      validationAudienceLevel: audienceLevel
      validationTags: tags
      validationPreviousTalkVideo: previousTalkVideo
      validationSpeakerLevel: speakerLevel
      validationShortSocialSummary: shortSocialSummary
      validationSpeakerBio: speakerBio
      validationSpeakerWebsite: speakerWebsite
      validationSpeakerPhoto: speakerPhoto
      validationSpeakerTwitterHandle: speakerTwitterHandle
      validationSpeakerInstagramHandle: speakerInstagramHandle
      validationSpeakerLinkedinUrl: speakerLinkedinUrl
      validationSpeakerFacebookUrl: speakerFacebookUrl
      nonFieldErrors
    }
  }
}
    `;
export type SendSubmissionMutationFn = Apollo.MutationFunction<SendSubmissionMutation, SendSubmissionMutationVariables>;

/**
 * __useSendSubmissionMutation__
 *
 * To run a mutation, you first call `useSendSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubmissionMutation, { data, loading, error }] = useSendSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSendSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<SendSubmissionMutation, SendSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSubmissionMutation, SendSubmissionMutationVariables>(SendSubmissionDocument, options);
      }
export type SendSubmissionMutationHookResult = ReturnType<typeof useSendSubmissionMutation>;
export type SendSubmissionMutationResult = Apollo.MutationResult<SendSubmissionMutation>;
export type SendSubmissionMutationOptions = Apollo.BaseMutationOptions<SendSubmissionMutation, SendSubmissionMutationVariables>;
export const MyEditProfileDocument = gql`
    query MyEditProfile($conference: String!) {
  me {
    id
    hashid
    email
    name
    fullName
    gender
    openToRecruiting
    openToNewsletter
    dateBirth
    country
    participant(conference: $conference) {
      id
      publicProfile
      photo
      bio
      website
      speakerLevel
      previousTalkVideo
      twitterHandle
      instagramHandle
      linkedinUrl
      facebookUrl
      mastodonHandle
    }
  }
}
    `;

/**
 * __useMyEditProfileQuery__
 *
 * To run a query within a React component, call `useMyEditProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEditProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEditProfileQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useMyEditProfileQuery(baseOptions: Apollo.QueryHookOptions<MyEditProfileQuery, MyEditProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEditProfileQuery, MyEditProfileQueryVariables>(MyEditProfileDocument, options);
      }
export function useMyEditProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEditProfileQuery, MyEditProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEditProfileQuery, MyEditProfileQueryVariables>(MyEditProfileDocument, options);
        }
export type MyEditProfileQueryHookResult = ReturnType<typeof useMyEditProfileQuery>;
export type MyEditProfileLazyQueryHookResult = ReturnType<typeof useMyEditProfileLazyQuery>;
export type MyEditProfileQueryResult = Apollo.QueryResult<MyEditProfileQuery, MyEditProfileQueryVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!, $updateParticipantInput: UpdateParticipantInput!) {
  updateProfile(input: $input) {
    __typename
    ... on User {
      id
      name
      fullName
      gender
      openToRecruiting
      openToNewsletter
      country
      dateBirth
    }
    ... on UpdateProfileValidationError {
      errors {
        name {
          message
        }
        dateBirth {
          message
        }
        fullName {
          message
        }
        gender {
          message
        }
        name {
          message
        }
        openToRecruiting {
          message
        }
        openToNewsletter {
          message
        }
        country {
          message
        }
      }
    }
  }
  updateParticipant(input: $updateParticipantInput) {
    __typename
    ... on Participant {
      id
      bio
      website
      photo
      publicProfile
      twitterHandle
      instagramHandle
      linkedinUrl
      facebookUrl
      mastodonHandle
    }
    ... on UpdateParticipantValidationError {
      errors {
        bio
        website
        photo
        twitterHandle
        instagramHandle
        linkedinUrl
        facebookUrl
        mastodonHandle
      }
    }
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateParticipantInput: // value for 'updateParticipantInput'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const GenerateParticipantAvatarUploadUrlDocument = gql`
    mutation GenerateParticipantAvatarUploadUrl {
  generateParticipantAvatarUploadUrl {
    uploadUrl
    fileUrl
  }
}
    `;
export type GenerateParticipantAvatarUploadUrlMutationFn = Apollo.MutationFunction<GenerateParticipantAvatarUploadUrlMutation, GenerateParticipantAvatarUploadUrlMutationVariables>;

/**
 * __useGenerateParticipantAvatarUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateParticipantAvatarUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateParticipantAvatarUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateParticipantAvatarUploadUrlMutation, { data, loading, error }] = useGenerateParticipantAvatarUploadUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateParticipantAvatarUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateParticipantAvatarUploadUrlMutation, GenerateParticipantAvatarUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateParticipantAvatarUploadUrlMutation, GenerateParticipantAvatarUploadUrlMutationVariables>(GenerateParticipantAvatarUploadUrlDocument, options);
      }
export type GenerateParticipantAvatarUploadUrlMutationHookResult = ReturnType<typeof useGenerateParticipantAvatarUploadUrlMutation>;
export type GenerateParticipantAvatarUploadUrlMutationResult = Apollo.MutationResult<GenerateParticipantAvatarUploadUrlMutation>;
export type GenerateParticipantAvatarUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateParticipantAvatarUploadUrlMutation, GenerateParticipantAvatarUploadUrlMutationVariables>;
export const FooterDocument = gql`
    query Footer($code: String!) {
  conference(code: $code) {
    id
    footerEn: menu(identifier: "footer") {
      links {
        text: title(language: "en")
        link: href(language: "en")
      }
    }
    footerIt: menu(identifier: "footer") {
      links {
        text: title(language: "it")
        link: href(language: "it")
      }
    }
  }
}
    `;

/**
 * __useFooterQuery__
 *
 * To run a query within a React component, call `useFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useFooterQuery(baseOptions: Apollo.QueryHookOptions<FooterQuery, FooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
      }
export function useFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterQuery, FooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FooterQuery, FooterQueryVariables>(FooterDocument, options);
        }
export type FooterQueryHookResult = ReturnType<typeof useFooterQuery>;
export type FooterLazyQueryHookResult = ReturnType<typeof useFooterLazyQuery>;
export type FooterQueryResult = Apollo.QueryResult<FooterQuery, FooterQueryVariables>;
export const GrantDeadlineDocument = gql`
    query GrantDeadline($conference: String!) {
  conference(code: $conference) {
    id
    deadline(type: "grants") {
      id
      start
      end
      status
    }
  }
}
    `;

/**
 * __useGrantDeadlineQuery__
 *
 * To run a query within a React component, call `useGrantDeadlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrantDeadlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrantDeadlineQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useGrantDeadlineQuery(baseOptions: Apollo.QueryHookOptions<GrantDeadlineQuery, GrantDeadlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrantDeadlineQuery, GrantDeadlineQueryVariables>(GrantDeadlineDocument, options);
      }
export function useGrantDeadlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrantDeadlineQuery, GrantDeadlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrantDeadlineQuery, GrantDeadlineQueryVariables>(GrantDeadlineDocument, options);
        }
export type GrantDeadlineQueryHookResult = ReturnType<typeof useGrantDeadlineQuery>;
export type GrantDeadlineLazyQueryHookResult = ReturnType<typeof useGrantDeadlineLazyQuery>;
export type GrantDeadlineQueryResult = Apollo.QueryResult<GrantDeadlineQuery, GrantDeadlineQueryVariables>;
export const SendGrantDocument = gql`
    mutation SendGrant($input: SendGrantInput!) {
  mutationOp: sendGrant(input: $input) {
    __typename
    ... on Grant {
      id
    }
    ... on GrantErrors {
      validationConference: conference
      validationName: name
      validationFullName: fullName
      validationGender: gender
      validationGrantType: grantType
      validationOccupation: occupation
      validationAgeGroup: ageGroup
      validationPythonUsage: pythonUsage
      validationBeenToOtherEvents: beenToOtherEvents
      validationInterestedInVolunteering: interestedInVolunteering
      validationNeedsFundsForTravel: needsFundsForTravel
      validationWhy: why
      validationNotes: notes
      validationTravellingFrom: travellingFrom
      nonFieldErrors
    }
  }
}
    `;
export type SendGrantMutationFn = Apollo.MutationFunction<SendGrantMutation, SendGrantMutationVariables>;

/**
 * __useSendGrantMutation__
 *
 * To run a mutation, you first call `useSendGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGrantMutation, { data, loading, error }] = useSendGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendGrantMutation(baseOptions?: Apollo.MutationHookOptions<SendGrantMutation, SendGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGrantMutation, SendGrantMutationVariables>(SendGrantDocument, options);
      }
export type SendGrantMutationHookResult = ReturnType<typeof useSendGrantMutation>;
export type SendGrantMutationResult = Apollo.MutationResult<SendGrantMutation>;
export type SendGrantMutationOptions = Apollo.BaseMutationOptions<SendGrantMutation, SendGrantMutationVariables>;
export const HeaderDocument = gql`
    query Header($code: String!) {
  conference(code: $code) {
    id
    isRunning
    currentDay {
      day
      rooms {
        id
        streamingUrl
      }
    }
    conferenceMenuEn: menu(identifier: "conference-nav") {
      links {
        text: title(language: "en")
        link: href(language: "en")
        page {
          slug(language: "en")
        }
      }
    }
    programMenuEn: menu(identifier: "program-nav") {
      links {
        text: title(language: "en")
        link: href(language: "en")
        page {
          slug(language: "en")
        }
      }
    }
    conferenceMenuIt: menu(identifier: "conference-nav") {
      links {
        text: title(language: "it")
        link: href(language: "it")
        page {
          slug(language: "it")
        }
      }
    }
    programMenuIt: menu(identifier: "program-nav") {
      links {
        text: title(language: "it")
        link: href(language: "it")
        page {
          slug(language: "it")
        }
      }
    }
  }
}
    `;

/**
 * __useHeaderQuery__
 *
 * To run a query within a React component, call `useHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useHeaderQuery(baseOptions: Apollo.QueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
      }
export function useHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaderQuery, HeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaderQuery, HeaderQueryVariables>(HeaderDocument, options);
        }
export type HeaderQueryHookResult = ReturnType<typeof useHeaderQuery>;
export type HeaderLazyQueryHookResult = ReturnType<typeof useHeaderLazyQuery>;
export type HeaderQueryResult = Apollo.QueryResult<HeaderQuery, HeaderQueryVariables>;
export const IndexPageDocument = gql`
    query IndexPage($code: String!, $language: String!) {
  cmsPage(hostname: $code, slug: $code, language: $language) {
    ... on GenericPage {
      id
      title
      body {
        ...Blocks
      }
    }
  }
  conference(code: $code) {
    id
    name(language: $language)
    introduction(language: $language)
    isRunning
  }
}
    ${BlocksFragmentDoc}`;

/**
 * __useIndexPageQuery__
 *
 * To run a query within a React component, call `useIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexPageQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useIndexPageQuery(baseOptions: Apollo.QueryHookOptions<IndexPageQuery, IndexPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndexPageQuery, IndexPageQueryVariables>(IndexPageDocument, options);
      }
export function useIndexPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndexPageQuery, IndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndexPageQuery, IndexPageQueryVariables>(IndexPageDocument, options);
        }
export type IndexPageQueryHookResult = ReturnType<typeof useIndexPageQuery>;
export type IndexPageLazyQueryHookResult = ReturnType<typeof useIndexPageLazyQuery>;
export type IndexPageQueryResult = Apollo.QueryResult<IndexPageQuery, IndexPageQueryVariables>;
export const TagsDocument = gql`
    query Tags {
  submissionTags {
    name
    id
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const AllJobListingsDocument = gql`
    query AllJobListings($language: String!, $conference: String!) {
  jobListings(conference: $conference) {
    id
    slug(language: $language)
    title(language: $language)
    description(language: $language)
    applyUrl
    company
    companyLogo
  }
}
    `;

/**
 * __useAllJobListingsQuery__
 *
 * To run a query within a React component, call `useAllJobListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobListingsQuery({
 *   variables: {
 *      language: // value for 'language'
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useAllJobListingsQuery(baseOptions: Apollo.QueryHookOptions<AllJobListingsQuery, AllJobListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllJobListingsQuery, AllJobListingsQueryVariables>(AllJobListingsDocument, options);
      }
export function useAllJobListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllJobListingsQuery, AllJobListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllJobListingsQuery, AllJobListingsQueryVariables>(AllJobListingsDocument, options);
        }
export type AllJobListingsQueryHookResult = ReturnType<typeof useAllJobListingsQuery>;
export type AllJobListingsLazyQueryHookResult = ReturnType<typeof useAllJobListingsLazyQuery>;
export type AllJobListingsQueryResult = Apollo.QueryResult<AllJobListingsQuery, AllJobListingsQueryVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    __typename
    ... on LoginSuccess {
      user {
        id
      }
    }
    ... on LoginValidationError {
      errors {
        email {
          message
          type
        }
        password {
          message
          type
        }
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MyProfileWithOrdersDocument = gql`
    query MyProfileWithOrders($conference: String!) {
  me {
    id
    orders(conference: $conference) {
      code
      status
      url
      total
    }
  }
}
    `;

/**
 * __useMyProfileWithOrdersQuery__
 *
 * To run a query within a React component, call `useMyProfileWithOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileWithOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileWithOrdersQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useMyProfileWithOrdersQuery(baseOptions: Apollo.QueryHookOptions<MyProfileWithOrdersQuery, MyProfileWithOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileWithOrdersQuery, MyProfileWithOrdersQueryVariables>(MyProfileWithOrdersDocument, options);
      }
export function useMyProfileWithOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileWithOrdersQuery, MyProfileWithOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileWithOrdersQuery, MyProfileWithOrdersQueryVariables>(MyProfileWithOrdersDocument, options);
        }
export type MyProfileWithOrdersQueryHookResult = ReturnType<typeof useMyProfileWithOrdersQuery>;
export type MyProfileWithOrdersLazyQueryHookResult = ReturnType<typeof useMyProfileWithOrdersLazyQuery>;
export type MyProfileWithOrdersQueryResult = Apollo.QueryResult<MyProfileWithOrdersQuery, MyProfileWithOrdersQueryVariables>;
export const BadgeScansDocument = gql`
    query BadgeScans($conferenceCode: String!, $page: Int, $pageSize: Int!) {
  badgeScans(conferenceCode: $conferenceCode, page: $page, pageSize: $pageSize) {
    pageInfo {
      pageSize
      totalItems
      totalPages
    }
    items {
      id
      attendee {
        email
        fullName
      }
      created
      notes
    }
  }
}
    `;

/**
 * __useBadgeScansQuery__
 *
 * To run a query within a React component, call `useBadgeScansQuery` and pass it any options that fit your needs.
 * When your component renders, `useBadgeScansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBadgeScansQuery({
 *   variables: {
 *      conferenceCode: // value for 'conferenceCode'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useBadgeScansQuery(baseOptions: Apollo.QueryHookOptions<BadgeScansQuery, BadgeScansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BadgeScansQuery, BadgeScansQueryVariables>(BadgeScansDocument, options);
      }
export function useBadgeScansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BadgeScansQuery, BadgeScansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BadgeScansQuery, BadgeScansQueryVariables>(BadgeScansDocument, options);
        }
export type BadgeScansQueryHookResult = ReturnType<typeof useBadgeScansQuery>;
export type BadgeScansLazyQueryHookResult = ReturnType<typeof useBadgeScansLazyQuery>;
export type BadgeScansQueryResult = Apollo.QueryResult<BadgeScansQuery, BadgeScansQueryVariables>;
export const ExportBadgeScansDocument = gql`
    mutation ExportBadgeScans($conferenceCode: String!) {
  exportBadgeScans(conferenceCode: $conferenceCode) {
    id
    url
  }
}
    `;
export type ExportBadgeScansMutationFn = Apollo.MutationFunction<ExportBadgeScansMutation, ExportBadgeScansMutationVariables>;

/**
 * __useExportBadgeScansMutation__
 *
 * To run a mutation, you first call `useExportBadgeScansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportBadgeScansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportBadgeScansMutation, { data, loading, error }] = useExportBadgeScansMutation({
 *   variables: {
 *      conferenceCode: // value for 'conferenceCode'
 *   },
 * });
 */
export function useExportBadgeScansMutation(baseOptions?: Apollo.MutationHookOptions<ExportBadgeScansMutation, ExportBadgeScansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportBadgeScansMutation, ExportBadgeScansMutationVariables>(ExportBadgeScansDocument, options);
      }
export type ExportBadgeScansMutationHookResult = ReturnType<typeof useExportBadgeScansMutation>;
export type ExportBadgeScansMutationResult = Apollo.MutationResult<ExportBadgeScansMutation>;
export type ExportBadgeScansMutationOptions = Apollo.BaseMutationOptions<ExportBadgeScansMutation, ExportBadgeScansMutationVariables>;
export const MyProfileWithSubmissionsDocument = gql`
    query MyProfileWithSubmissions($conference: String!, $language: String!) {
  me {
    id
    name
    fullName
    email
    submissions(conference: $conference) {
      id
      title(language: $language)
      status
      scheduleItems {
        id
        start
        end
        status
      }
      type {
        id
        name
      }
    }
  }
  conference(code: $conference) {
    id
    deadline(type: "cfp") {
      id
      status
    }
  }
}
    `;

/**
 * __useMyProfileWithSubmissionsQuery__
 *
 * To run a query within a React component, call `useMyProfileWithSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileWithSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileWithSubmissionsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMyProfileWithSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<MyProfileWithSubmissionsQuery, MyProfileWithSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileWithSubmissionsQuery, MyProfileWithSubmissionsQueryVariables>(MyProfileWithSubmissionsDocument, options);
      }
export function useMyProfileWithSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileWithSubmissionsQuery, MyProfileWithSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileWithSubmissionsQuery, MyProfileWithSubmissionsQueryVariables>(MyProfileWithSubmissionsDocument, options);
        }
export type MyProfileWithSubmissionsQueryHookResult = ReturnType<typeof useMyProfileWithSubmissionsQuery>;
export type MyProfileWithSubmissionsLazyQueryHookResult = ReturnType<typeof useMyProfileWithSubmissionsLazyQuery>;
export type MyProfileWithSubmissionsQueryResult = Apollo.QueryResult<MyProfileWithSubmissionsQuery, MyProfileWithSubmissionsQueryVariables>;
export const MyProfileWithTicketsDocument = gql`
    query MyProfileWithTickets($conference: String!, $language: String!) {
  me {
    id
    name
    fullName
    email
    tickets(conference: $conference, language: $language) {
      id
      hashid
      name
      email
      secret
      variation
      role
      item {
        id
        name
        language
        description
        category
        admission
        variations {
          id
          value
        }
        questions {
          id
          hidden
          answer {
            answer
            options
          }
          name
          options {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyProfileWithTicketsQuery__
 *
 * To run a query within a React component, call `useMyProfileWithTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileWithTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileWithTicketsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMyProfileWithTicketsQuery(baseOptions: Apollo.QueryHookOptions<MyProfileWithTicketsQuery, MyProfileWithTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileWithTicketsQuery, MyProfileWithTicketsQueryVariables>(MyProfileWithTicketsDocument, options);
      }
export function useMyProfileWithTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileWithTicketsQuery, MyProfileWithTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileWithTicketsQuery, MyProfileWithTicketsQueryVariables>(MyProfileWithTicketsDocument, options);
        }
export type MyProfileWithTicketsQueryHookResult = ReturnType<typeof useMyProfileWithTicketsQuery>;
export type MyProfileWithTicketsLazyQueryHookResult = ReturnType<typeof useMyProfileWithTicketsLazyQuery>;
export type MyProfileWithTicketsQueryResult = Apollo.QueryResult<MyProfileWithTicketsQuery, MyProfileWithTicketsQueryVariables>;
export const UpdateTicketDocument = gql`
    mutation UpdateTicket($conference: String!, $input: UpdateAttendeeTicketInput!, $language: String!) {
  __typename
  updateAttendeeTicket(
    conference: $conference
    input: $input
    language: $language
  ) {
    __typename
    ... on AttendeeTicket {
      id
      name
      email
      item {
        id
        name
        language
        description
        category
        questions {
          id
          answer {
            answer
            options
          }
          name
          options {
            id
            name
          }
        }
      }
    }
    ... on TicketReassigned {
      id
      email
    }
    ... on UpdateAttendeeTicketErrors {
      id
      errors {
        field
        message
      }
    }
  }
}
    `;
export type UpdateTicketMutationFn = Apollo.MutationFunction<UpdateTicketMutation, UpdateTicketMutationVariables>;

/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketMutation, { data, loading, error }] = useUpdateTicketMutation({
 *   variables: {
 *      conference: // value for 'conference'
 *      input: // value for 'input'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateTicketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTicketMutation, UpdateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTicketMutation, UpdateTicketMutationVariables>(UpdateTicketDocument, options);
      }
export type UpdateTicketMutationHookResult = ReturnType<typeof useUpdateTicketMutation>;
export type UpdateTicketMutationResult = Apollo.MutationResult<UpdateTicketMutation>;
export type UpdateTicketMutationOptions = Apollo.BaseMutationOptions<UpdateTicketMutation, UpdateTicketMutationVariables>;
export const SubscribeDocument = gql`
    mutation subscribe($email: String!) {
  subscribeToNewsletter(input: {email: $email}) {
    __typename
    ... on NewsletterSubscribeResult {
      status
    }
    ... on SubscribeToNewsletterErrors {
      validationEmail: email
      nonFieldErrors
    }
  }
}
    `;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeMutation, SubscribeMutationVariables>(SubscribeDocument, options);
      }
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MyProfileDocument = gql`
    query MyProfile($conferenceCode: String!) {
  me {
    id
    name
    fullName
    conferenceRoles(conferenceCode: $conferenceCode)
  }
}
    `;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *      conferenceCode: // value for 'conferenceCode'
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const MyGrantDocument = gql`
    query MyGrant($conference: String!) {
  me {
    id
    grant(conference: $conference) {
      id
      status
      fullName
      name
      gender
      grantType
      occupation
      ageGroup
      pythonUsage
      beenToOtherEvents
      interestedInVolunteering
      needsFundsForTravel
      why
      notes
      travellingFrom
    }
  }
}
    `;

/**
 * __useMyGrantQuery__
 *
 * To run a query within a React component, call `useMyGrantQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGrantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGrantQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useMyGrantQuery(baseOptions: Apollo.QueryHookOptions<MyGrantQuery, MyGrantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGrantQuery, MyGrantQueryVariables>(MyGrantDocument, options);
      }
export function useMyGrantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGrantQuery, MyGrantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGrantQuery, MyGrantQueryVariables>(MyGrantDocument, options);
        }
export type MyGrantQueryHookResult = ReturnType<typeof useMyGrantQuery>;
export type MyGrantLazyQueryHookResult = ReturnType<typeof useMyGrantLazyQuery>;
export type MyGrantQueryResult = Apollo.QueryResult<MyGrantQuery, MyGrantQueryVariables>;
export const ParticipantPublicProfileDocument = gql`
    query ParticipantPublicProfile($userId: ID!, $conference: String!) {
  participant(userId: $userId, conference: $conference) {
    id
    fullname
    publicProfile
    bio
    website
    photo
    publicProfile
    twitterHandle
    instagramHandle
    linkedinUrl
    facebookUrl
    mastodonHandle
  }
}
    `;

/**
 * __useParticipantPublicProfileQuery__
 *
 * To run a query within a React component, call `useParticipantPublicProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantPublicProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantPublicProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useParticipantPublicProfileQuery(baseOptions: Apollo.QueryHookOptions<ParticipantPublicProfileQuery, ParticipantPublicProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantPublicProfileQuery, ParticipantPublicProfileQueryVariables>(ParticipantPublicProfileDocument, options);
      }
export function useParticipantPublicProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantPublicProfileQuery, ParticipantPublicProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantPublicProfileQuery, ParticipantPublicProfileQueryVariables>(ParticipantPublicProfileDocument, options);
        }
export type ParticipantPublicProfileQueryHookResult = ReturnType<typeof useParticipantPublicProfileQuery>;
export type ParticipantPublicProfileLazyQueryHookResult = ReturnType<typeof useParticipantPublicProfileLazyQuery>;
export type ParticipantPublicProfileQueryResult = Apollo.QueryResult<ParticipantPublicProfileQuery, ParticipantPublicProfileQueryVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestResetPassword(email: $email) {
    __typename
    ... on OperationSuccess {
      ok
    }
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($token: String!, $password: String!) {
  resetPassword(input: {token: $token, newPassword: $password}) {
    __typename
    ... on ResetPasswordValidationError {
      errors {
        token {
          message
        }
        newPassword {
          message
        }
      }
    }
    ... on OperationSuccess {
      ok
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const BookScheduleItemDocument = gql`
    mutation BookScheduleItem($id: ID!) {
  bookScheduleItem(id: $id) {
    __typename
    ... on ScheduleItem {
      id
      userHasSpot
      spacesLeft
      hasSpacesLeft
    }
  }
}
    `;
export type BookScheduleItemMutationFn = Apollo.MutationFunction<BookScheduleItemMutation, BookScheduleItemMutationVariables>;

/**
 * __useBookScheduleItemMutation__
 *
 * To run a mutation, you first call `useBookScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookScheduleItemMutation, { data, loading, error }] = useBookScheduleItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookScheduleItemMutation(baseOptions?: Apollo.MutationHookOptions<BookScheduleItemMutation, BookScheduleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookScheduleItemMutation, BookScheduleItemMutationVariables>(BookScheduleItemDocument, options);
      }
export type BookScheduleItemMutationHookResult = ReturnType<typeof useBookScheduleItemMutation>;
export type BookScheduleItemMutationResult = Apollo.MutationResult<BookScheduleItemMutation>;
export type BookScheduleItemMutationOptions = Apollo.BaseMutationOptions<BookScheduleItemMutation, BookScheduleItemMutationVariables>;
export const CancelBookingScheduleItemDocument = gql`
    mutation CancelBookingScheduleItem($id: ID!) {
  cancelBookingScheduleItem(id: $id) {
    __typename
    ... on ScheduleItem {
      id
      userHasSpot
      hasSpacesLeft
      spacesLeft
    }
  }
}
    `;
export type CancelBookingScheduleItemMutationFn = Apollo.MutationFunction<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>;

/**
 * __useCancelBookingScheduleItemMutation__
 *
 * To run a mutation, you first call `useCancelBookingScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingScheduleItemMutation, { data, loading, error }] = useCancelBookingScheduleItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelBookingScheduleItemMutation(baseOptions?: Apollo.MutationHookOptions<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>(CancelBookingScheduleItemDocument, options);
      }
export type CancelBookingScheduleItemMutationHookResult = ReturnType<typeof useCancelBookingScheduleItemMutation>;
export type CancelBookingScheduleItemMutationResult = Apollo.MutationResult<CancelBookingScheduleItemMutation>;
export type CancelBookingScheduleItemMutationOptions = Apollo.BaseMutationOptions<CancelBookingScheduleItemMutation, CancelBookingScheduleItemMutationVariables>;
export const TalkDocument = gql`
    query Talk($slug: String!, $code: String!, $language: String!) {
  conference(code: $code) {
    id
    talk(slug: $slug) {
      id
      title
      type
      image
      highlightColor
      description
      hasLimitedCapacity
      spacesLeft
      hasSpacesLeft
      slidoUrl
      youtubeVideoId
      start
      end
      rooms {
        id
        name
      }
      language {
        code
      }
      submission {
        id
        abstract(language: $language)
        elevatorPitch(language: $language)
        duration {
          id
          duration
        }
        audienceLevel {
          id
          name
        }
        topic {
          name
        }
        tags {
          name
          id
        }
      }
      speakers {
        id
        participant {
          id
          photo
          fullname
          bio
          twitterHandle
          instagramHandle
          linkedinUrl
          facebookUrl
          mastodonHandle
          website
        }
      }
    }
  }
}
    `;

/**
 * __useTalkQuery__
 *
 * To run a query within a React component, call `useTalkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalkQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTalkQuery(baseOptions: Apollo.QueryHookOptions<TalkQuery, TalkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalkQuery, TalkQueryVariables>(TalkDocument, options);
      }
export function useTalkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalkQuery, TalkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalkQuery, TalkQueryVariables>(TalkDocument, options);
        }
export type TalkQueryHookResult = ReturnType<typeof useTalkQuery>;
export type TalkLazyQueryHookResult = ReturnType<typeof useTalkLazyQuery>;
export type TalkQueryResult = Apollo.QueryResult<TalkQuery, TalkQueryVariables>;
export const StarScheduleItemDocument = gql`
    mutation StarScheduleItem($id: ID!) {
  starScheduleItem(id: $id)
}
    `;
export type StarScheduleItemMutationFn = Apollo.MutationFunction<StarScheduleItemMutation, StarScheduleItemMutationVariables>;

/**
 * __useStarScheduleItemMutation__
 *
 * To run a mutation, you first call `useStarScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starScheduleItemMutation, { data, loading, error }] = useStarScheduleItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStarScheduleItemMutation(baseOptions?: Apollo.MutationHookOptions<StarScheduleItemMutation, StarScheduleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StarScheduleItemMutation, StarScheduleItemMutationVariables>(StarScheduleItemDocument, options);
      }
export type StarScheduleItemMutationHookResult = ReturnType<typeof useStarScheduleItemMutation>;
export type StarScheduleItemMutationResult = Apollo.MutationResult<StarScheduleItemMutation>;
export type StarScheduleItemMutationOptions = Apollo.BaseMutationOptions<StarScheduleItemMutation, StarScheduleItemMutationVariables>;
export const UnstarScheduleItemDocument = gql`
    mutation UnstarScheduleItem($id: ID!) {
  unstarScheduleItem(id: $id)
}
    `;
export type UnstarScheduleItemMutationFn = Apollo.MutationFunction<UnstarScheduleItemMutation, UnstarScheduleItemMutationVariables>;

/**
 * __useUnstarScheduleItemMutation__
 *
 * To run a mutation, you first call `useUnstarScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarScheduleItemMutation, { data, loading, error }] = useUnstarScheduleItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnstarScheduleItemMutation(baseOptions?: Apollo.MutationHookOptions<UnstarScheduleItemMutation, UnstarScheduleItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnstarScheduleItemMutation, UnstarScheduleItemMutationVariables>(UnstarScheduleItemDocument, options);
      }
export type UnstarScheduleItemMutationHookResult = ReturnType<typeof useUnstarScheduleItemMutation>;
export type UnstarScheduleItemMutationResult = Apollo.MutationResult<UnstarScheduleItemMutation>;
export type UnstarScheduleItemMutationOptions = Apollo.BaseMutationOptions<UnstarScheduleItemMutation, UnstarScheduleItemMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($input: RegisterInput!) {
  register(input: $input) {
    __typename
    ... on RegisterSuccess {
      user {
        id
        email
        fullname
        name
      }
    }
    ... on EmailAlreadyUsed {
      message
    }
    ... on RegisterValidationError {
      errors {
        email {
          message
          type
        }
        password {
          message
          type
        }
        fullname {
          message
          type
        }
      }
    }
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const SubmissionDocument = gql`
    query Submission($id: ID!, $language: String!) {
  submission(id: $id) {
    id
    title(language: $language)
    abstract(language: $language)
    elevatorPitch(language: $language)
    notes
    canEdit
    type {
      id
      name
    }
    duration {
      id
      name
      duration
    }
    audienceLevel {
      id
      name
    }
    languages {
      id
      name
      code
    }
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useSubmissionQuery__
 *
 * To run a query within a React component, call `useSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSubmissionQuery(baseOptions: Apollo.QueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
      }
export function useSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
        }
export type SubmissionQueryHookResult = ReturnType<typeof useSubmissionQuery>;
export type SubmissionLazyQueryHookResult = ReturnType<typeof useSubmissionLazyQuery>;
export type SubmissionQueryResult = Apollo.QueryResult<SubmissionQuery, SubmissionQueryVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($conference: String!, $input: CreateOrderInput!) {
  createOrder(conference: $conference, input: $input) {
    ... on Error {
      message
    }
    ... on CreateOrderResult {
      paymentUrl
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      conference: // value for 'conference'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const GetVoucherDocument = gql`
    query GetVoucher($conference: String!, $code: String!) {
  conference(code: $conference) {
    id
    voucher(code: $code) {
      id
      code
      value
      redeemed
      maxUsages
      priceMode
      items
      allItems
      variationId
      validUntil
    }
  }
}
    `;

/**
 * __useGetVoucherQuery__
 *
 * To run a query within a React component, call `useGetVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetVoucherQuery(baseOptions: Apollo.QueryHookOptions<GetVoucherQuery, GetVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoucherQuery, GetVoucherQueryVariables>(GetVoucherDocument, options);
      }
export function useGetVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoucherQuery, GetVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoucherQuery, GetVoucherQueryVariables>(GetVoucherDocument, options);
        }
export type GetVoucherQueryHookResult = ReturnType<typeof useGetVoucherQuery>;
export type GetVoucherLazyQueryHookResult = ReturnType<typeof useGetVoucherLazyQuery>;
export type GetVoucherQueryResult = Apollo.QueryResult<GetVoucherQuery, GetVoucherQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    code
    name
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    id
    name
    fullName
    email
    gender
    dateBirth
    country
    openToRecruiting
    openToNewsletter
    canEditSchedule
    isPythonItaliaMember
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const AllPagesDocument = gql`
    query AllPages($code: String!, $language: String!) {
  cmsPages(hostname: $code, language: $language) {
    id
    slug
  }
}
    `;

/**
 * __useAllPagesQuery__
 *
 * To run a query within a React component, call `useAllPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPagesQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAllPagesQuery(baseOptions: Apollo.QueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
      }
export function useAllPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPagesQuery, AllPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPagesQuery, AllPagesQueryVariables>(AllPagesDocument, options);
        }
export type AllPagesQueryHookResult = ReturnType<typeof useAllPagesQuery>;
export type AllPagesLazyQueryHookResult = ReturnType<typeof useAllPagesLazyQuery>;
export type AllPagesQueryResult = Apollo.QueryResult<AllPagesQuery, AllPagesQueryVariables>;
export const PageDocument = gql`
    query Page($code: String!, $slug: String!, $language: String!) {
  cmsPage(hostname: $code, slug: $slug, language: $language) {
    ... on GenericPage {
      id
      title
      searchDescription
      body {
        ...Blocks
      }
    }
  }
}
    ${BlocksFragmentDoc}`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      code: // value for 'code'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const TicketIdToUserHashidDocument = gql`
    query TicketIdToUserHashid($ticketId: ID!, $conference: String!) {
  ticketIdToUserHashid(ticketId: $ticketId, conferenceCode: $conference)
}
    `;

/**
 * __useTicketIdToUserHashidQuery__
 *
 * To run a query within a React component, call `useTicketIdToUserHashidQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketIdToUserHashidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketIdToUserHashidQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useTicketIdToUserHashidQuery(baseOptions: Apollo.QueryHookOptions<TicketIdToUserHashidQuery, TicketIdToUserHashidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketIdToUserHashidQuery, TicketIdToUserHashidQueryVariables>(TicketIdToUserHashidDocument, options);
      }
export function useTicketIdToUserHashidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketIdToUserHashidQuery, TicketIdToUserHashidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketIdToUserHashidQuery, TicketIdToUserHashidQueryVariables>(TicketIdToUserHashidDocument, options);
        }
export type TicketIdToUserHashidQueryHookResult = ReturnType<typeof useTicketIdToUserHashidQuery>;
export type TicketIdToUserHashidLazyQueryHookResult = ReturnType<typeof useTicketIdToUserHashidLazyQuery>;
export type TicketIdToUserHashidQueryResult = Apollo.QueryResult<TicketIdToUserHashidQuery, TicketIdToUserHashidQueryVariables>;
export const IsCfpOpenDocument = gql`
    query IsCfpOpen($conference: String!) {
  conference(code: $conference) {
    id
    isCFPOpen
    cfpDeadline: deadline(type: "cfp") {
      id
      end
    }
  }
}
    `;

/**
 * __useIsCfpOpenQuery__
 *
 * To run a query within a React component, call `useIsCfpOpenQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCfpOpenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCfpOpenQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useIsCfpOpenQuery(baseOptions: Apollo.QueryHookOptions<IsCfpOpenQuery, IsCfpOpenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCfpOpenQuery, IsCfpOpenQueryVariables>(IsCfpOpenDocument, options);
      }
export function useIsCfpOpenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCfpOpenQuery, IsCfpOpenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCfpOpenQuery, IsCfpOpenQueryVariables>(IsCfpOpenDocument, options);
        }
export type IsCfpOpenQueryHookResult = ReturnType<typeof useIsCfpOpenQuery>;
export type IsCfpOpenLazyQueryHookResult = ReturnType<typeof useIsCfpOpenLazyQuery>;
export type IsCfpOpenQueryResult = Apollo.QueryResult<IsCfpOpenQuery, IsCfpOpenQueryVariables>;
export const MeSubmissionsDocument = gql`
    query MeSubmissions($conference: String!, $language: String!) {
  me {
    id
    submissions(conference: $conference) {
      id
      title(language: $language)
    }
  }
}
    `;

/**
 * __useMeSubmissionsQuery__
 *
 * To run a query within a React component, call `useMeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeSubmissionsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMeSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<MeSubmissionsQuery, MeSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>(MeSubmissionsDocument, options);
      }
export function useMeSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeSubmissionsQuery, MeSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>(MeSubmissionsDocument, options);
        }
export type MeSubmissionsQueryHookResult = ReturnType<typeof useMeSubmissionsQuery>;
export type MeSubmissionsLazyQueryHookResult = ReturnType<typeof useMeSubmissionsLazyQuery>;
export type MeSubmissionsQueryResult = Apollo.QueryResult<MeSubmissionsQuery, MeSubmissionsQueryVariables>;
export const TalkSocialCardDocument = gql`
    query TalkSocialCard($slug: String!, $code: String!) {
  conference(code: $code) {
    id
    talk(slug: $slug) {
      id
      title
      speakers {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useTalkSocialCardQuery__
 *
 * To run a query within a React component, call `useTalkSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalkSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalkSocialCardQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTalkSocialCardQuery(baseOptions: Apollo.QueryHookOptions<TalkSocialCardQuery, TalkSocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalkSocialCardQuery, TalkSocialCardQueryVariables>(TalkSocialCardDocument, options);
      }
export function useTalkSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalkSocialCardQuery, TalkSocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalkSocialCardQuery, TalkSocialCardQueryVariables>(TalkSocialCardDocument, options);
        }
export type TalkSocialCardQueryHookResult = ReturnType<typeof useTalkSocialCardQuery>;
export type TalkSocialCardLazyQueryHookResult = ReturnType<typeof useTalkSocialCardLazyQuery>;
export type TalkSocialCardQueryResult = Apollo.QueryResult<TalkSocialCardQuery, TalkSocialCardQueryVariables>;
export const AllTalksDocument = gql`
    query AllTalks($code: String!) {
  conference(code: $code) {
    id
    talks {
      id
      slug
    }
  }
}
    `;

/**
 * __useAllTalksQuery__
 *
 * To run a query within a React component, call `useAllTalksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTalksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTalksQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAllTalksQuery(baseOptions: Apollo.QueryHookOptions<AllTalksQuery, AllTalksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTalksQuery, AllTalksQueryVariables>(AllTalksDocument, options);
      }
export function useAllTalksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTalksQuery, AllTalksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTalksQuery, AllTalksQueryVariables>(AllTalksDocument, options);
        }
export type AllTalksQueryHookResult = ReturnType<typeof useAllTalksQuery>;
export type AllTalksLazyQueryHookResult = ReturnType<typeof useAllTalksLazyQuery>;
export type AllTalksQueryResult = Apollo.QueryResult<AllTalksQuery, AllTalksQueryVariables>;
export const WorkshopBookingStateDocument = gql`
    query WorkshopBookingState($slug: String!, $code: String!) {
  conference(code: $code) {
    id
    talk(slug: $slug) {
      id
      hasLimitedCapacity
      spacesLeft
      hasSpacesLeft
      userHasSpot
    }
  }
}
    `;

/**
 * __useWorkshopBookingStateQuery__
 *
 * To run a query within a React component, call `useWorkshopBookingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkshopBookingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkshopBookingStateQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useWorkshopBookingStateQuery(baseOptions: Apollo.QueryHookOptions<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>(WorkshopBookingStateDocument, options);
      }
export function useWorkshopBookingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>(WorkshopBookingStateDocument, options);
        }
export type WorkshopBookingStateQueryHookResult = ReturnType<typeof useWorkshopBookingStateQuery>;
export type WorkshopBookingStateLazyQueryHookResult = ReturnType<typeof useWorkshopBookingStateLazyQuery>;
export type WorkshopBookingStateQueryResult = Apollo.QueryResult<WorkshopBookingStateQuery, WorkshopBookingStateQueryVariables>;
export const UpdateGrantDocument = gql`
    mutation UpdateGrant($input: UpdateGrantInput!) {
  mutationOp: updateGrant(input: $input) {
    __typename
    ... on Grant {
      id
      name
      fullName
      gender
      grantType
      occupation
      ageGroup
      pythonUsage
      beenToOtherEvents
      interestedInVolunteering
      needsFundsForTravel
      notes
      travellingFrom
    }
    ... on GrantErrors {
      validationConference: conference
      validationName: name
      validationFullName: fullName
      validationGender: gender
      validationGrantType: grantType
      validationOccupation: occupation
      validationAgeGroup: ageGroup
      validationPythonUsage: pythonUsage
      validationBeenToOtherEvents: beenToOtherEvents
      validationInterestedInVolunteering: interestedInVolunteering
      validationNeedsFundsForTravel: needsFundsForTravel
      validationWhy: why
      validationNotes: notes
      validationTravellingFrom: travellingFrom
      nonFieldErrors
    }
  }
}
    `;
export type UpdateGrantMutationFn = Apollo.MutationFunction<UpdateGrantMutation, UpdateGrantMutationVariables>;

/**
 * __useUpdateGrantMutation__
 *
 * To run a mutation, you first call `useUpdateGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrantMutation, { data, loading, error }] = useUpdateGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGrantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrantMutation, UpdateGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGrantMutation, UpdateGrantMutationVariables>(UpdateGrantDocument, options);
      }
export type UpdateGrantMutationHookResult = ReturnType<typeof useUpdateGrantMutation>;
export type UpdateGrantMutationResult = Apollo.MutationResult<UpdateGrantMutation>;
export type UpdateGrantMutationOptions = Apollo.BaseMutationOptions<UpdateGrantMutation, UpdateGrantMutationVariables>;
export const GrantDocument = gql`
    query Grant($conference: String!) {
  me {
    id
    grant(conference: $conference) {
      id
      status
      applicantReplyDeadline
      applicantMessage
    }
  }
}
    `;

/**
 * __useGrantQuery__
 *
 * To run a query within a React component, call `useGrantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrantQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useGrantQuery(baseOptions: Apollo.QueryHookOptions<GrantQuery, GrantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrantQuery, GrantQueryVariables>(GrantDocument, options);
      }
export function useGrantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrantQuery, GrantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrantQuery, GrantQueryVariables>(GrantDocument, options);
        }
export type GrantQueryHookResult = ReturnType<typeof useGrantQuery>;
export type GrantLazyQueryHookResult = ReturnType<typeof useGrantLazyQuery>;
export type GrantQueryResult = Apollo.QueryResult<GrantQuery, GrantQueryVariables>;
export const SendGrantReplyDocument = gql`
    mutation SendGrantReply($input: SendGrantReplyInput!) {
  sendGrantReply(input: $input) {
    ... on SendGrantReplyError {
      message
    }
    ... on Grant {
      id
      status
    }
  }
}
    `;
export type SendGrantReplyMutationFn = Apollo.MutationFunction<SendGrantReplyMutation, SendGrantReplyMutationVariables>;

/**
 * __useSendGrantReplyMutation__
 *
 * To run a mutation, you first call `useSendGrantReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGrantReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGrantReplyMutation, { data, loading, error }] = useSendGrantReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendGrantReplyMutation(baseOptions?: Apollo.MutationHookOptions<SendGrantReplyMutation, SendGrantReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGrantReplyMutation, SendGrantReplyMutationVariables>(SendGrantReplyDocument, options);
      }
export type SendGrantReplyMutationHookResult = ReturnType<typeof useSendGrantReplyMutation>;
export type SendGrantReplyMutationResult = Apollo.MutationResult<SendGrantReplyMutation>;
export type SendGrantReplyMutationOptions = Apollo.BaseMutationOptions<SendGrantReplyMutation, SendGrantReplyMutationVariables>;
export const KeynoteSocialCardDocument = gql`
    query KeynoteSocialCard($conference: String!, $slug: String!, $language: String!) {
  conference(code: $conference) {
    id
    keynote(slug: $slug) {
      id
      title(language: $language)
      speakers {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useKeynoteSocialCardQuery__
 *
 * To run a query within a React component, call `useKeynoteSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynoteSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynoteSocialCardQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynoteSocialCardQuery(baseOptions: Apollo.QueryHookOptions<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>(KeynoteSocialCardDocument, options);
      }
export function useKeynoteSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>(KeynoteSocialCardDocument, options);
        }
export type KeynoteSocialCardQueryHookResult = ReturnType<typeof useKeynoteSocialCardQuery>;
export type KeynoteSocialCardLazyQueryHookResult = ReturnType<typeof useKeynoteSocialCardLazyQuery>;
export type KeynoteSocialCardQueryResult = Apollo.QueryResult<KeynoteSocialCardQuery, KeynoteSocialCardQueryVariables>;
export const AllKeynotesDocument = gql`
    query AllKeynotes($conference: String!, $language: String!) {
  conference(code: $conference) {
    id
    keynotes {
      id
      slug(language: $language)
    }
  }
}
    `;

/**
 * __useAllKeynotesQuery__
 *
 * To run a query within a React component, call `useAllKeynotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllKeynotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllKeynotesQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAllKeynotesQuery(baseOptions: Apollo.QueryHookOptions<AllKeynotesQuery, AllKeynotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllKeynotesQuery, AllKeynotesQueryVariables>(AllKeynotesDocument, options);
      }
export function useAllKeynotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllKeynotesQuery, AllKeynotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllKeynotesQuery, AllKeynotesQueryVariables>(AllKeynotesDocument, options);
        }
export type AllKeynotesQueryHookResult = ReturnType<typeof useAllKeynotesQuery>;
export type AllKeynotesLazyQueryHookResult = ReturnType<typeof useAllKeynotesLazyQuery>;
export type AllKeynotesQueryResult = Apollo.QueryResult<AllKeynotesQuery, AllKeynotesQueryVariables>;
export const KeynoteDocument = gql`
    query Keynote($conference: String!, $slug: String!, $language: String!) {
  conference(code: $conference) {
    id
    keynote(slug: $slug) {
      id
      title(language: $language)
      description(language: $language)
      slug(language: $language)
      start
      end
      youtubeVideoId
      rooms {
        id
        name
      }
      topic {
        id
        name
      }
      speakers {
        id
        participant {
          id
          photo
          bio
          fullname
          twitterHandle
          instagramHandle
          linkedinUrl
          facebookUrl
          mastodonHandle
          website
        }
      }
    }
  }
}
    `;

/**
 * __useKeynoteQuery__
 *
 * To run a query within a React component, call `useKeynoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynoteQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynoteQuery(baseOptions: Apollo.QueryHookOptions<KeynoteQuery, KeynoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynoteQuery, KeynoteQueryVariables>(KeynoteDocument, options);
      }
export function useKeynoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynoteQuery, KeynoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynoteQuery, KeynoteQueryVariables>(KeynoteDocument, options);
        }
export type KeynoteQueryHookResult = ReturnType<typeof useKeynoteQuery>;
export type KeynoteLazyQueryHookResult = ReturnType<typeof useKeynoteLazyQuery>;
export type KeynoteQueryResult = Apollo.QueryResult<KeynoteQuery, KeynoteQueryVariables>;
export const KeynotesPageDocument = gql`
    query KeynotesPage($conference: String!, $language: String!) {
  conference(code: $conference) {
    id
    title: copy(key: "keynotes-title", language: $language)
    subtitle: copy(key: "keynotes-subtitle", language: $language)
    description: copy(key: "keynotes-description", language: $language)
    keynotes {
      id
      title(language: $language)
      slug(language: $language)
      start
      speakers {
        id
        participant {
          id
          photo
          fullname
          twitterHandle
          instagramHandle
          linkedinUrl
          facebookUrl
          mastodonHandle
        }
      }
    }
  }
}
    `;

/**
 * __useKeynotesPageQuery__
 *
 * To run a query within a React component, call `useKeynotesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeynotesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeynotesPageQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useKeynotesPageQuery(baseOptions: Apollo.QueryHookOptions<KeynotesPageQuery, KeynotesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeynotesPageQuery, KeynotesPageQueryVariables>(KeynotesPageDocument, options);
      }
export function useKeynotesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeynotesPageQuery, KeynotesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeynotesPageQuery, KeynotesPageQueryVariables>(KeynotesPageDocument, options);
        }
export type KeynotesPageQueryHookResult = ReturnType<typeof useKeynotesPageQuery>;
export type KeynotesPageLazyQueryHookResult = ReturnType<typeof useKeynotesPageLazyQuery>;
export type KeynotesPageQueryResult = Apollo.QueryResult<KeynotesPageQuery, KeynotesPageQueryVariables>;
export const AllNewsArticlesDocument = gql`
    query AllNewsArticles($code: String!, $language: String!) {
  newsArticles(hostname: $code, language: $language) {
    id
    slug
  }
}
    `;

/**
 * __useAllNewsArticlesQuery__
 *
 * To run a query within a React component, call `useAllNewsArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNewsArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNewsArticlesQuery({
 *   variables: {
 *      code: // value for 'code'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAllNewsArticlesQuery(baseOptions: Apollo.QueryHookOptions<AllNewsArticlesQuery, AllNewsArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllNewsArticlesQuery, AllNewsArticlesQueryVariables>(AllNewsArticlesDocument, options);
      }
export function useAllNewsArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllNewsArticlesQuery, AllNewsArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllNewsArticlesQuery, AllNewsArticlesQueryVariables>(AllNewsArticlesDocument, options);
        }
export type AllNewsArticlesQueryHookResult = ReturnType<typeof useAllNewsArticlesQuery>;
export type AllNewsArticlesLazyQueryHookResult = ReturnType<typeof useAllNewsArticlesLazyQuery>;
export type AllNewsArticlesQueryResult = Apollo.QueryResult<AllNewsArticlesQuery, AllNewsArticlesQueryVariables>;
export const NewsArticleSocialCardDocument = gql`
    query NewsArticleSocialCard($code: String!, $slug: String!, $language: String!) {
  newsArticle(hostname: $code, slug: $slug, language: $language) {
    id
    title
    authorFullname
  }
}
    `;

/**
 * __useNewsArticleSocialCardQuery__
 *
 * To run a query within a React component, call `useNewsArticleSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsArticleSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsArticleSocialCardQuery({
 *   variables: {
 *      code: // value for 'code'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useNewsArticleSocialCardQuery(baseOptions: Apollo.QueryHookOptions<NewsArticleSocialCardQuery, NewsArticleSocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsArticleSocialCardQuery, NewsArticleSocialCardQueryVariables>(NewsArticleSocialCardDocument, options);
      }
export function useNewsArticleSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsArticleSocialCardQuery, NewsArticleSocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsArticleSocialCardQuery, NewsArticleSocialCardQueryVariables>(NewsArticleSocialCardDocument, options);
        }
export type NewsArticleSocialCardQueryHookResult = ReturnType<typeof useNewsArticleSocialCardQuery>;
export type NewsArticleSocialCardLazyQueryHookResult = ReturnType<typeof useNewsArticleSocialCardLazyQuery>;
export type NewsArticleSocialCardQueryResult = Apollo.QueryResult<NewsArticleSocialCardQuery, NewsArticleSocialCardQueryVariables>;
export const NewsArticleDocument = gql`
    query NewsArticle($code: String!, $slug: String!, $language: String!) {
  newsArticle(hostname: $code, slug: $slug, language: $language) {
    id
    title
    excerpt
    body
    publishedAt
    authorFullname
  }
  blogPost(slug: $slug) {
    id
    title(language: $language)
    content(language: $language)
    excerpt(language: $language)
    author {
      fullName
    }
    published
  }
}
    `;

/**
 * __useNewsArticleQuery__
 *
 * To run a query within a React component, call `useNewsArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsArticleQuery({
 *   variables: {
 *      code: // value for 'code'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useNewsArticleQuery(baseOptions: Apollo.QueryHookOptions<NewsArticleQuery, NewsArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsArticleQuery, NewsArticleQueryVariables>(NewsArticleDocument, options);
      }
export function useNewsArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsArticleQuery, NewsArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsArticleQuery, NewsArticleQueryVariables>(NewsArticleDocument, options);
        }
export type NewsArticleQueryHookResult = ReturnType<typeof useNewsArticleQuery>;
export type NewsArticleLazyQueryHookResult = ReturnType<typeof useNewsArticleLazyQuery>;
export type NewsArticleQueryResult = Apollo.QueryResult<NewsArticleQuery, NewsArticleQueryVariables>;
export const OrderDocument = gql`
    query Order($conferenceCode: String!, $code: String!) {
  order(conferenceCode: $conferenceCode, code: $code) {
    code
    status
    url
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      conferenceCode: // value for 'conferenceCode'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const AddScheduleSlotDocument = gql`
    mutation AddScheduleSlot($code: ID!, $day: Date!, $duration: Int!, $language: String!) {
  addScheduleSlot(conference: $code, day: $day, duration: $duration) {
    ... on Day {
      day
      slots {
        ...ScheduleSlotFragment
      }
    }
  }
}
    ${ScheduleSlotFragmentFragmentDoc}`;
export type AddScheduleSlotMutationFn = Apollo.MutationFunction<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>;

/**
 * __useAddScheduleSlotMutation__
 *
 * To run a mutation, you first call `useAddScheduleSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduleSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScheduleSlotMutation, { data, loading, error }] = useAddScheduleSlotMutation({
 *   variables: {
 *      code: // value for 'code'
 *      day: // value for 'day'
 *      duration: // value for 'duration'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAddScheduleSlotMutation(baseOptions?: Apollo.MutationHookOptions<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>(AddScheduleSlotDocument, options);
      }
export type AddScheduleSlotMutationHookResult = ReturnType<typeof useAddScheduleSlotMutation>;
export type AddScheduleSlotMutationResult = Apollo.MutationResult<AddScheduleSlotMutation>;
export type AddScheduleSlotMutationOptions = Apollo.BaseMutationOptions<AddScheduleSlotMutation, AddScheduleSlotMutationVariables>;
export const GetScheduleInvitationDocument = gql`
    query GetScheduleInvitation($submissionId: ID!, $language: String!) {
  scheduleInvitation(submissionId: $submissionId) {
    id
    option
    notes
    title
    submission {
      id
      title(language: $language)
    }
    dates {
      id
      start
      end
    }
  }
}
    `;

/**
 * __useGetScheduleInvitationQuery__
 *
 * To run a query within a React component, call `useGetScheduleInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleInvitationQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetScheduleInvitationQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>(GetScheduleInvitationDocument, options);
      }
export function useGetScheduleInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>(GetScheduleInvitationDocument, options);
        }
export type GetScheduleInvitationQueryHookResult = ReturnType<typeof useGetScheduleInvitationQuery>;
export type GetScheduleInvitationLazyQueryHookResult = ReturnType<typeof useGetScheduleInvitationLazyQuery>;
export type GetScheduleInvitationQueryResult = Apollo.QueryResult<GetScheduleInvitationQuery, GetScheduleInvitationQueryVariables>;
export const UpdateScheduleInvitationDocument = gql`
    mutation UpdateScheduleInvitation($input: UpdateScheduleInvitationInput!) {
  updateScheduleInvitation(input: $input) {
    __typename
    ... on ScheduleInvitation {
      id
      option
      notes
    }
    ... on ScheduleInvitationNotFound {
      message
    }
  }
}
    `;
export type UpdateScheduleInvitationMutationFn = Apollo.MutationFunction<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>;

/**
 * __useUpdateScheduleInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleInvitationMutation, { data, loading, error }] = useUpdateScheduleInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>(UpdateScheduleInvitationDocument, options);
      }
export type UpdateScheduleInvitationMutationHookResult = ReturnType<typeof useUpdateScheduleInvitationMutation>;
export type UpdateScheduleInvitationMutationResult = Apollo.MutationResult<UpdateScheduleInvitationMutation>;
export type UpdateScheduleInvitationMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleInvitationMutation, UpdateScheduleInvitationMutationVariables>;
export const ScheduleDaysDocument = gql`
    query ScheduleDays($code: String!) {
  conference(code: $code) {
    id
    days {
      day
    }
  }
}
    `;

/**
 * __useScheduleDaysQuery__
 *
 * To run a query within a React component, call `useScheduleDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleDaysQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useScheduleDaysQuery(baseOptions: Apollo.QueryHookOptions<ScheduleDaysQuery, ScheduleDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleDaysQuery, ScheduleDaysQueryVariables>(ScheduleDaysDocument, options);
      }
export function useScheduleDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleDaysQuery, ScheduleDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleDaysQuery, ScheduleDaysQueryVariables>(ScheduleDaysDocument, options);
        }
export type ScheduleDaysQueryHookResult = ReturnType<typeof useScheduleDaysQuery>;
export type ScheduleDaysLazyQueryHookResult = ReturnType<typeof useScheduleDaysLazyQuery>;
export type ScheduleDaysQueryResult = Apollo.QueryResult<ScheduleDaysQuery, ScheduleDaysQueryVariables>;
export const ScheduleDocument = gql`
    query Schedule($code: String!, $fetchSubmissions: Boolean!, $language: String!) {
  conference(code: $code) {
    id
    timezone
    days {
      day
      rooms {
        id
        name
        type
      }
      slots {
        ...ScheduleSlotFragment
      }
    }
    submissions @include(if: $fetchSubmissions) {
      ...SubmissionFragment
    }
    keynotes @include(if: $fetchSubmissions) {
      ...KeynoteFragment
    }
    audienceLevels {
      id
      name
    }
    durations {
      id
      duration
      allowedSubmissionTypes {
        name
      }
    }
  }
}
    ${ScheduleSlotFragmentFragmentDoc}
${SubmissionFragmentFragmentDoc}
${KeynoteFragmentFragmentDoc}`;

/**
 * __useScheduleQuery__
 *
 * To run a query within a React component, call `useScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleQuery({
 *   variables: {
 *      code: // value for 'code'
 *      fetchSubmissions: // value for 'fetchSubmissions'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useScheduleQuery(baseOptions: Apollo.QueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
      }
export function useScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
        }
export type ScheduleQueryHookResult = ReturnType<typeof useScheduleQuery>;
export type ScheduleLazyQueryHookResult = ReturnType<typeof useScheduleLazyQuery>;
export type ScheduleQueryResult = Apollo.QueryResult<ScheduleQuery, ScheduleQueryVariables>;
export const UpdateOrCreateSlotItemDocument = gql`
    mutation UpdateOrCreateSlotItem($input: UpdateOrCreateSlotItemInput!, $language: String!) {
  updateOrCreateSlotItem(input: $input) {
    ... on UpdateOrCreateSlotItemResult {
      updatedSlots {
        ...ScheduleSlotFragment
      }
    }
  }
}
    ${ScheduleSlotFragmentFragmentDoc}`;
export type UpdateOrCreateSlotItemMutationFn = Apollo.MutationFunction<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>;

/**
 * __useUpdateOrCreateSlotItemMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateSlotItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateSlotItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateSlotItemMutation, { data, loading, error }] = useUpdateOrCreateSlotItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateOrCreateSlotItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>(UpdateOrCreateSlotItemDocument, options);
      }
export type UpdateOrCreateSlotItemMutationHookResult = ReturnType<typeof useUpdateOrCreateSlotItemMutation>;
export type UpdateOrCreateSlotItemMutationResult = Apollo.MutationResult<UpdateOrCreateSlotItemMutation>;
export type UpdateOrCreateSlotItemMutationOptions = Apollo.BaseMutationOptions<UpdateOrCreateSlotItemMutation, UpdateOrCreateSlotItemMutationVariables>;
export const UserStarredScheduleItemsDocument = gql`
    query UserStarredScheduleItems($code: String!) {
  me {
    id
    starredScheduleItems(conference: $code)
  }
}
    `;

/**
 * __useUserStarredScheduleItemsQuery__
 *
 * To run a query within a React component, call `useUserStarredScheduleItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStarredScheduleItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStarredScheduleItemsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUserStarredScheduleItemsQuery(baseOptions: Apollo.QueryHookOptions<UserStarredScheduleItemsQuery, UserStarredScheduleItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStarredScheduleItemsQuery, UserStarredScheduleItemsQueryVariables>(UserStarredScheduleItemsDocument, options);
      }
export function useUserStarredScheduleItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStarredScheduleItemsQuery, UserStarredScheduleItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStarredScheduleItemsQuery, UserStarredScheduleItemsQueryVariables>(UserStarredScheduleItemsDocument, options);
        }
export type UserStarredScheduleItemsQueryHookResult = ReturnType<typeof useUserStarredScheduleItemsQuery>;
export type UserStarredScheduleItemsLazyQueryHookResult = ReturnType<typeof useUserStarredScheduleItemsLazyQuery>;
export type UserStarredScheduleItemsQueryResult = Apollo.QueryResult<UserStarredScheduleItemsQuery, UserStarredScheduleItemsQueryVariables>;
export const SocialCardDocument = gql`
    query SocialCard($code: String!) {
  conference(code: $code) {
    id
    start
    end
    name
  }
}
    `;

/**
 * __useSocialCardQuery__
 *
 * To run a query within a React component, call `useSocialCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCardQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSocialCardQuery(baseOptions: Apollo.QueryHookOptions<SocialCardQuery, SocialCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialCardQuery, SocialCardQueryVariables>(SocialCardDocument, options);
      }
export function useSocialCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialCardQuery, SocialCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialCardQuery, SocialCardQueryVariables>(SocialCardDocument, options);
        }
export type SocialCardQueryHookResult = ReturnType<typeof useSocialCardQuery>;
export type SocialCardLazyQueryHookResult = ReturnType<typeof useSocialCardLazyQuery>;
export type SocialCardQueryResult = Apollo.QueryResult<SocialCardQuery, SocialCardQueryVariables>;
export const GetSubmissionDocument = gql`
    query GetSubmission($id: ID!, $language: String!) {
  submission(id: $id) {
    id
    title(language: $language)
    abstract(language: $language)
    elevatorPitch(language: $language)
    shortSocialSummary
    multilingualTitle {
      it
      en
    }
    multilingualAbstract {
      it
      en
    }
    multilingualElevatorPitch {
      it
      en
    }
    type {
      id
      name
    }
    notes
    canEdit
    speakerLevel
    previousTalkVideo
    topic {
      id
      name
    }
    duration {
      id
      name
    }
    audienceLevel {
      id
      name
    }
    languages {
      id
      code
      name
    }
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSubmissionQuery__
 *
 * To run a query within a React component, call `useGetSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetSubmissionQuery, GetSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(GetSubmissionDocument, options);
      }
export function useGetSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionQuery, GetSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionQuery, GetSubmissionQueryVariables>(GetSubmissionDocument, options);
        }
export type GetSubmissionQueryHookResult = ReturnType<typeof useGetSubmissionQuery>;
export type GetSubmissionLazyQueryHookResult = ReturnType<typeof useGetSubmissionLazyQuery>;
export type GetSubmissionQueryResult = Apollo.QueryResult<GetSubmissionQuery, GetSubmissionQueryVariables>;
export const UpdateSubmissionDocument = gql`
    mutation UpdateSubmission($input: UpdateSubmissionInput!, $language: String!) {
  mutationOp: updateSubmission(input: $input) {
    __typename
    ... on Submission {
      id
      title(language: $language)
      abstract(language: $language)
      elevatorPitch(language: $language)
      shortSocialSummary
      multilingualTitle {
        it
        en
      }
      multilingualAbstract {
        it
        en
      }
      multilingualElevatorPitch {
        it
        en
      }
      type {
        id
        name
      }
      notes
      speakerLevel
      previousTalkVideo
      topic {
        id
        name
      }
      duration {
        id
        name
      }
      audienceLevel {
        id
        name
      }
      languages {
        id
        code
        name
      }
      tags {
        id
        name
      }
    }
    ... on SendSubmissionErrors {
      validationTitle: title
      validationAbstract: abstract
      validationTopic: topic
      validationLanguages: languages
      validationType: type
      validationDuration: duration
      validationElevatorPitch: elevatorPitch
      validationNotes: notes
      validationAudienceLevel: audienceLevel
      validationTags: tags
      validationPreviousTalkVideo: previousTalkVideo
      validationSpeakerLevel: speakerLevel
      validationShortSocialSummary: shortSocialSummary
      validationSpeakerBio: speakerBio
      validationSpeakerWebsite: speakerWebsite
      validationSpeakerPhoto: speakerPhoto
      validationSpeakerTwitterHandle: speakerTwitterHandle
      validationSpeakerInstagramHandle: speakerInstagramHandle
      validationSpeakerLinkedinUrl: speakerLinkedinUrl
      validationSpeakerFacebookUrl: speakerFacebookUrl
      validationSpeakerMastodonHandle: speakerMastodonHandle
      nonFieldErrors
    }
  }
}
    `;
export type UpdateSubmissionMutationFn = Apollo.MutationFunction<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>;

/**
 * __useUpdateSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubmissionMutation, { data, loading, error }] = useUpdateSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>(UpdateSubmissionDocument, options);
      }
export type UpdateSubmissionMutationHookResult = ReturnType<typeof useUpdateSubmissionMutation>;
export type UpdateSubmissionMutationResult = Apollo.MutationResult<UpdateSubmissionMutation>;
export type UpdateSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>;
export const IsVotingClosedDocument = gql`
    query IsVotingClosed($conference: String!) {
  conference(code: $conference) {
    id
    isVotingClosed
  }
}
    `;

/**
 * __useIsVotingClosedQuery__
 *
 * To run a query within a React component, call `useIsVotingClosedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsVotingClosedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsVotingClosedQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useIsVotingClosedQuery(baseOptions: Apollo.QueryHookOptions<IsVotingClosedQuery, IsVotingClosedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsVotingClosedQuery, IsVotingClosedQueryVariables>(IsVotingClosedDocument, options);
      }
export function useIsVotingClosedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsVotingClosedQuery, IsVotingClosedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsVotingClosedQuery, IsVotingClosedQueryVariables>(IsVotingClosedDocument, options);
        }
export type IsVotingClosedQueryHookResult = ReturnType<typeof useIsVotingClosedQuery>;
export type IsVotingClosedLazyQueryHookResult = ReturnType<typeof useIsVotingClosedLazyQuery>;
export type IsVotingClosedQueryResult = Apollo.QueryResult<IsVotingClosedQuery, IsVotingClosedQueryVariables>;
export const TicketsDocument = gql`
    query Tickets($conference: String!, $language: String!) {
  conference(code: $conference) {
    ...ConferenceProducts
  }
}
    ${ConferenceProductsFragmentDoc}`;

/**
 * __useTicketsQuery__
 *
 * To run a query within a React component, call `useTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTicketsQuery(baseOptions: Apollo.QueryHookOptions<TicketsQuery, TicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketsQuery, TicketsQueryVariables>(TicketsDocument, options);
      }
export function useTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketsQuery, TicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketsQuery, TicketsQueryVariables>(TicketsDocument, options);
        }
export type TicketsQueryHookResult = ReturnType<typeof useTicketsQuery>;
export type TicketsLazyQueryHookResult = ReturnType<typeof useTicketsLazyQuery>;
export type TicketsQueryResult = Apollo.QueryResult<TicketsQuery, TicketsQueryVariables>;
export const SendVoteDocument = gql`
    mutation SendVote($input: SendVoteInput!) {
  sendVote(input: $input) {
    __typename
    ... on VoteType {
      id
      value
    }
    ... on SendVoteErrors {
      validationValue: value
      validationSubmission: submission
      nonFieldErrors
    }
  }
}
    `;
export type SendVoteMutationFn = Apollo.MutationFunction<SendVoteMutation, SendVoteMutationVariables>;

/**
 * __useSendVoteMutation__
 *
 * To run a mutation, you first call `useSendVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVoteMutation, { data, loading, error }] = useSendVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendVoteMutation(baseOptions?: Apollo.MutationHookOptions<SendVoteMutation, SendVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVoteMutation, SendVoteMutationVariables>(SendVoteDocument, options);
      }
export type SendVoteMutationHookResult = ReturnType<typeof useSendVoteMutation>;
export type SendVoteMutationResult = Apollo.MutationResult<SendVoteMutation>;
export type SendVoteMutationOptions = Apollo.BaseMutationOptions<SendVoteMutation, SendVoteMutationVariables>;
export const VotingMetadataDocument = gql`
    query VotingMetadata($conference: String!) {
  conference(code: $conference) {
    id
    isVotingOpen
    votingDeadline: deadline(type: "voting") {
      id
      end
    }
    topics {
      id
      name
    }
    languages {
      id
      name
      code
    }
    audienceLevels {
      id
      name
    }
    submissionTypes {
      id
      name
    }
  }
  votingTags(conference: $conference) {
    id
    name
  }
}
    `;

/**
 * __useVotingMetadataQuery__
 *
 * To run a query within a React component, call `useVotingMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useVotingMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVotingMetadataQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *   },
 * });
 */
export function useVotingMetadataQuery(baseOptions: Apollo.QueryHookOptions<VotingMetadataQuery, VotingMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VotingMetadataQuery, VotingMetadataQueryVariables>(VotingMetadataDocument, options);
      }
export function useVotingMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VotingMetadataQuery, VotingMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VotingMetadataQuery, VotingMetadataQueryVariables>(VotingMetadataDocument, options);
        }
export type VotingMetadataQueryHookResult = ReturnType<typeof useVotingMetadataQuery>;
export type VotingMetadataLazyQueryHookResult = ReturnType<typeof useVotingMetadataLazyQuery>;
export type VotingMetadataQueryResult = Apollo.QueryResult<VotingMetadataQuery, VotingMetadataQueryVariables>;
export const VotingSubmissionsDocument = gql`
    query VotingSubmissions($conference: String!, $language: String!, $languages: [String!], $voted: Boolean, $tags: [String!], $types: [String!], $audienceLevels: [String!], $page: Int) {
  submissions(
    code: $conference
    languages: $languages
    voted: $voted
    tags: $tags
    types: $types
    audienceLevels: $audienceLevels
    page: $page
    pageSize: 100
  ) {
    pageInfo {
      totalPages
      totalItems
    }
    items {
      ...submissionAccordion
    }
  }
}
    ${SubmissionAccordionFragmentDoc}`;

/**
 * __useVotingSubmissionsQuery__
 *
 * To run a query within a React component, call `useVotingSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVotingSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVotingSubmissionsQuery({
 *   variables: {
 *      conference: // value for 'conference'
 *      language: // value for 'language'
 *      languages: // value for 'languages'
 *      voted: // value for 'voted'
 *      tags: // value for 'tags'
 *      types: // value for 'types'
 *      audienceLevels: // value for 'audienceLevels'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useVotingSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>(VotingSubmissionsDocument, options);
      }
export function useVotingSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>(VotingSubmissionsDocument, options);
        }
export type VotingSubmissionsQueryHookResult = ReturnType<typeof useVotingSubmissionsQuery>;
export type VotingSubmissionsLazyQueryHookResult = ReturnType<typeof useVotingSubmissionsLazyQuery>;
export type VotingSubmissionsQueryResult = Apollo.QueryResult<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>;

  type MeSubmissionsQueryCacheReadOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: MeSubmissionsQueryVariables;
  }

  type MeSubmissionsQueryCacheWriteOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: MeSubmissionsQueryVariables;
    data: MeSubmissionsQuery;
  }

  export function readMeSubmissionsQueryCache<TMutation>(options: MeSubmissionsQueryCacheReadOptions<TMutation>) {
    return options.cache.readQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>({
      query: MeSubmissionsDocument,
      variables: options.variables,
    });
  }

  export function writeMeSubmissionsQueryCache<TMutation>(options: MeSubmissionsQueryCacheWriteOptions<TMutation>) {
    return options.cache.writeQuery<MeSubmissionsQuery, MeSubmissionsQueryVariables>({
      query: MeSubmissionsDocument,
      variables: options.variables,
      data: options.data,
    });
  }

  type UserStarredScheduleItemsQueryCacheReadOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: UserStarredScheduleItemsQueryVariables;
  }

  type UserStarredScheduleItemsQueryCacheWriteOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: UserStarredScheduleItemsQueryVariables;
    data: UserStarredScheduleItemsQuery;
  }

  export function readUserStarredScheduleItemsQueryCache<TMutation>(options: UserStarredScheduleItemsQueryCacheReadOptions<TMutation>) {
    return options.cache.readQuery<UserStarredScheduleItemsQuery, UserStarredScheduleItemsQueryVariables>({
      query: UserStarredScheduleItemsDocument,
      variables: options.variables,
    });
  }

  export function writeUserStarredScheduleItemsQueryCache<TMutation>(options: UserStarredScheduleItemsQueryCacheWriteOptions<TMutation>) {
    return options.cache.writeQuery<UserStarredScheduleItemsQuery, UserStarredScheduleItemsQueryVariables>({
      query: UserStarredScheduleItemsDocument,
      variables: options.variables,
      data: options.data,
    });
  }

  type VotingSubmissionsQueryCacheReadOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: VotingSubmissionsQueryVariables;
  }

  type VotingSubmissionsQueryCacheWriteOptions<TMutation> = {
    cache: Apollo.ApolloCache<TMutation>;
    variables: VotingSubmissionsQueryVariables;
    data: VotingSubmissionsQuery;
  }

  export function readVotingSubmissionsQueryCache<TMutation>(options: VotingSubmissionsQueryCacheReadOptions<TMutation>) {
    return options.cache.readQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>({
      query: VotingSubmissionsDocument,
      variables: options.variables,
    });
  }

  export function writeVotingSubmissionsQueryCache<TMutation>(options: VotingSubmissionsQueryCacheWriteOptions<TMutation>) {
    return options.cache.writeQuery<VotingSubmissionsQuery, VotingSubmissionsQueryVariables>({
      query: VotingSubmissionsDocument,
      variables: options.variables,
      data: options.data,
    });
  }


export async function queryCheckoutSection(client: ApolloClient<any>, variables?: CheckoutSectionQueryVariables): Promise<CheckoutSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: CheckoutSectionDocument,
    variables,
  });
}


export async function queryInformationSection(client: ApolloClient<any>, variables?: InformationSectionQueryVariables): Promise<InformationSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: InformationSectionDocument,
    variables,
  });
}


export async function queryKeynotesSection(client: ApolloClient<any>, variables?: KeynotesSectionQueryVariables): Promise<KeynotesSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynotesSectionDocument,
    variables,
  });
}


export async function queryLiveStreamingSection(client: ApolloClient<any>, variables?: LiveStreamingSectionQueryVariables): Promise<LiveStreamingSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: LiveStreamingSectionDocument,
    variables,
  });
}


export async function queryNewsGridSection(client: ApolloClient<any>, variables?: NewsGridSectionQueryVariables): Promise<NewsGridSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: NewsGridSectionDocument,
    variables,
  });
}


export async function querySchedulePreviewSection(client: ApolloClient<any>, variables?: SchedulePreviewSectionQueryVariables): Promise<SchedulePreviewSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: SchedulePreviewSectionDocument,
    variables,
  });
}


export async function querySponsorsSection(client: ApolloClient<any>, variables?: SponsorsSectionQueryVariables): Promise<SponsorsSectionQueryResult> {
  // @ts-ignore
  return client.query({
    query: SponsorsSectionDocument,
    variables,
  });
}


export async function queryCfpForm(client: ApolloClient<any>, variables?: CfpFormQueryVariables): Promise<CfpFormQueryResult> {
  // @ts-ignore
  return client.query({
    query: CfpFormDocument,
    variables,
  });
}


export async function queryParticipantData(client: ApolloClient<any>, variables?: ParticipantDataQueryVariables): Promise<ParticipantDataQueryResult> {
  // @ts-ignore
  return client.query({
    query: ParticipantDataDocument,
    variables,
  });
}


export async function queryMyEditProfile(client: ApolloClient<any>, variables?: MyEditProfileQueryVariables): Promise<MyEditProfileQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyEditProfileDocument,
    variables,
  });
}


export async function queryFooter(client: ApolloClient<any>, variables?: FooterQueryVariables): Promise<FooterQueryResult> {
  // @ts-ignore
  return client.query({
    query: FooterDocument,
    variables,
  });
}


export async function queryGrantDeadline(client: ApolloClient<any>, variables?: GrantDeadlineQueryVariables): Promise<GrantDeadlineQueryResult> {
  // @ts-ignore
  return client.query({
    query: GrantDeadlineDocument,
    variables,
  });
}


export async function queryHeader(client: ApolloClient<any>, variables?: HeaderQueryVariables): Promise<HeaderQueryResult> {
  // @ts-ignore
  return client.query({
    query: HeaderDocument,
    variables,
  });
}


export async function queryIndexPage(client: ApolloClient<any>, variables?: IndexPageQueryVariables): Promise<IndexPageQueryResult> {
  // @ts-ignore
  return client.query({
    query: IndexPageDocument,
    variables,
  });
}


export async function queryTags(client: ApolloClient<any>, variables?: TagsQueryVariables): Promise<TagsQueryResult> {
  // @ts-ignore
  return client.query({
    query: TagsDocument,
    variables,
  });
}


export async function queryAllJobListings(client: ApolloClient<any>, variables?: AllJobListingsQueryVariables): Promise<AllJobListingsQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllJobListingsDocument,
    variables,
  });
}


export async function queryMyProfileWithOrders(client: ApolloClient<any>, variables?: MyProfileWithOrdersQueryVariables): Promise<MyProfileWithOrdersQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyProfileWithOrdersDocument,
    variables,
  });
}


export async function queryBadgeScans(client: ApolloClient<any>, variables?: BadgeScansQueryVariables): Promise<BadgeScansQueryResult> {
  // @ts-ignore
  return client.query({
    query: BadgeScansDocument,
    variables,
  });
}


export async function queryMyProfileWithSubmissions(client: ApolloClient<any>, variables?: MyProfileWithSubmissionsQueryVariables): Promise<MyProfileWithSubmissionsQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyProfileWithSubmissionsDocument,
    variables,
  });
}


export async function queryMyProfileWithTickets(client: ApolloClient<any>, variables?: MyProfileWithTicketsQueryVariables): Promise<MyProfileWithTicketsQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyProfileWithTicketsDocument,
    variables,
  });
}


export async function queryMyProfile(client: ApolloClient<any>, variables?: MyProfileQueryVariables): Promise<MyProfileQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyProfileDocument,
    variables,
  });
}


export async function queryMyGrant(client: ApolloClient<any>, variables?: MyGrantQueryVariables): Promise<MyGrantQueryResult> {
  // @ts-ignore
  return client.query({
    query: MyGrantDocument,
    variables,
  });
}


export async function queryParticipantPublicProfile(client: ApolloClient<any>, variables?: ParticipantPublicProfileQueryVariables): Promise<ParticipantPublicProfileQueryResult> {
  // @ts-ignore
  return client.query({
    query: ParticipantPublicProfileDocument,
    variables,
  });
}


export async function queryTalk(client: ApolloClient<any>, variables?: TalkQueryVariables): Promise<TalkQueryResult> {
  // @ts-ignore
  return client.query({
    query: TalkDocument,
    variables,
  });
}


export async function querySubmission(client: ApolloClient<any>, variables?: SubmissionQueryVariables): Promise<SubmissionQueryResult> {
  // @ts-ignore
  return client.query({
    query: SubmissionDocument,
    variables,
  });
}


export async function queryGetVoucher(client: ApolloClient<any>, variables?: GetVoucherQueryVariables): Promise<GetVoucherQueryResult> {
  // @ts-ignore
  return client.query({
    query: GetVoucherDocument,
    variables,
  });
}


export async function queryCountries(client: ApolloClient<any>, variables?: CountriesQueryVariables): Promise<CountriesQueryResult> {
  // @ts-ignore
  return client.query({
    query: CountriesDocument,
    variables,
  });
}


export async function queryCurrentUser(client: ApolloClient<any>, variables?: CurrentUserQueryVariables): Promise<CurrentUserQueryResult> {
  // @ts-ignore
  return client.query({
    query: CurrentUserDocument,
    variables,
  });
}


export async function queryAllPages(client: ApolloClient<any>, variables?: AllPagesQueryVariables): Promise<AllPagesQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllPagesDocument,
    variables,
  });
}


export async function queryPage(client: ApolloClient<any>, variables?: PageQueryVariables): Promise<PageQueryResult> {
  // @ts-ignore
  return client.query({
    query: PageDocument,
    variables,
  });
}


export async function queryTicketIdToUserHashid(client: ApolloClient<any>, variables?: TicketIdToUserHashidQueryVariables): Promise<TicketIdToUserHashidQueryResult> {
  // @ts-ignore
  return client.query({
    query: TicketIdToUserHashidDocument,
    variables,
  });
}


export async function queryIsCfpOpen(client: ApolloClient<any>, variables?: IsCfpOpenQueryVariables): Promise<IsCfpOpenQueryResult> {
  // @ts-ignore
  return client.query({
    query: IsCfpOpenDocument,
    variables,
  });
}


export async function queryMeSubmissions(client: ApolloClient<any>, variables?: MeSubmissionsQueryVariables): Promise<MeSubmissionsQueryResult> {
  // @ts-ignore
  return client.query({
    query: MeSubmissionsDocument,
    variables,
  });
}


export async function queryTalkSocialCard(client: ApolloClient<any>, variables?: TalkSocialCardQueryVariables): Promise<TalkSocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: TalkSocialCardDocument,
    variables,
  });
}


export async function queryAllTalks(client: ApolloClient<any>, variables?: AllTalksQueryVariables): Promise<AllTalksQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllTalksDocument,
    variables,
  });
}


export async function queryWorkshopBookingState(client: ApolloClient<any>, variables?: WorkshopBookingStateQueryVariables): Promise<WorkshopBookingStateQueryResult> {
  // @ts-ignore
  return client.query({
    query: WorkshopBookingStateDocument,
    variables,
  });
}


export async function queryGrant(client: ApolloClient<any>, variables?: GrantQueryVariables): Promise<GrantQueryResult> {
  // @ts-ignore
  return client.query({
    query: GrantDocument,
    variables,
  });
}


export async function queryKeynoteSocialCard(client: ApolloClient<any>, variables?: KeynoteSocialCardQueryVariables): Promise<KeynoteSocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynoteSocialCardDocument,
    variables,
  });
}


export async function queryAllKeynotes(client: ApolloClient<any>, variables?: AllKeynotesQueryVariables): Promise<AllKeynotesQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllKeynotesDocument,
    variables,
  });
}


export async function queryKeynote(client: ApolloClient<any>, variables?: KeynoteQueryVariables): Promise<KeynoteQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynoteDocument,
    variables,
  });
}


export async function queryKeynotesPage(client: ApolloClient<any>, variables?: KeynotesPageQueryVariables): Promise<KeynotesPageQueryResult> {
  // @ts-ignore
  return client.query({
    query: KeynotesPageDocument,
    variables,
  });
}


export async function queryAllNewsArticles(client: ApolloClient<any>, variables?: AllNewsArticlesQueryVariables): Promise<AllNewsArticlesQueryResult> {
  // @ts-ignore
  return client.query({
    query: AllNewsArticlesDocument,
    variables,
  });
}


export async function queryNewsArticleSocialCard(client: ApolloClient<any>, variables?: NewsArticleSocialCardQueryVariables): Promise<NewsArticleSocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: NewsArticleSocialCardDocument,
    variables,
  });
}


export async function queryNewsArticle(client: ApolloClient<any>, variables?: NewsArticleQueryVariables): Promise<NewsArticleQueryResult> {
  // @ts-ignore
  return client.query({
    query: NewsArticleDocument,
    variables,
  });
}


export async function queryOrder(client: ApolloClient<any>, variables?: OrderQueryVariables): Promise<OrderQueryResult> {
  // @ts-ignore
  return client.query({
    query: OrderDocument,
    variables,
  });
}


export async function queryGetScheduleInvitation(client: ApolloClient<any>, variables?: GetScheduleInvitationQueryVariables): Promise<GetScheduleInvitationQueryResult> {
  // @ts-ignore
  return client.query({
    query: GetScheduleInvitationDocument,
    variables,
  });
}


export async function queryScheduleDays(client: ApolloClient<any>, variables?: ScheduleDaysQueryVariables): Promise<ScheduleDaysQueryResult> {
  // @ts-ignore
  return client.query({
    query: ScheduleDaysDocument,
    variables,
  });
}


export async function querySchedule(client: ApolloClient<any>, variables?: ScheduleQueryVariables): Promise<ScheduleQueryResult> {
  // @ts-ignore
  return client.query({
    query: ScheduleDocument,
    variables,
  });
}


export async function queryUserStarredScheduleItems(client: ApolloClient<any>, variables?: UserStarredScheduleItemsQueryVariables): Promise<UserStarredScheduleItemsQueryResult> {
  // @ts-ignore
  return client.query({
    query: UserStarredScheduleItemsDocument,
    variables,
  });
}


export async function querySocialCard(client: ApolloClient<any>, variables?: SocialCardQueryVariables): Promise<SocialCardQueryResult> {
  // @ts-ignore
  return client.query({
    query: SocialCardDocument,
    variables,
  });
}


export async function queryGetSubmission(client: ApolloClient<any>, variables?: GetSubmissionQueryVariables): Promise<GetSubmissionQueryResult> {
  // @ts-ignore
  return client.query({
    query: GetSubmissionDocument,
    variables,
  });
}


export async function queryIsVotingClosed(client: ApolloClient<any>, variables?: IsVotingClosedQueryVariables): Promise<IsVotingClosedQueryResult> {
  // @ts-ignore
  return client.query({
    query: IsVotingClosedDocument,
    variables,
  });
}


export async function queryTickets(client: ApolloClient<any>, variables?: TicketsQueryVariables): Promise<TicketsQueryResult> {
  // @ts-ignore
  return client.query({
    query: TicketsDocument,
    variables,
  });
}


export async function queryVotingMetadata(client: ApolloClient<any>, variables?: VotingMetadataQueryVariables): Promise<VotingMetadataQueryResult> {
  // @ts-ignore
  return client.query({
    query: VotingMetadataDocument,
    variables,
  });
}


export async function queryVotingSubmissions(client: ApolloClient<any>, variables?: VotingSubmissionsQueryVariables): Promise<VotingSubmissionsQueryResult> {
  // @ts-ignore
  return client.query({
    query: VotingSubmissionsDocument,
    variables,
  });
}

